angular.module('AlumniApp', [
    'ui.router',
    'ngResource',
    'ui.bootstrap',
    'ngSanitize',
    'ngMessages',
    'angularFileUpload',
    'angular.filter',
    'ngTable',
    'ngAnimate',
    'ngTagsInput',
    'powerbi',
    'ui.select',
    'colorpicker.module',
    'ui.mask',
    'ion.rangeslider',
    'frapontillo.bootstrap-switch',
    'thatisuday.dropzone'
])
    .animation('.ng-if-slidable', () => ({
        enter(element) {
            element.hide().slideDown();
            return function () {};
        },
        leave(element) {
            element.slideUp();
        }
    }))
    .config([
        '$stateProvider',
        '$urlRouterProvider',
        '$httpProvider',
        'START_ROUTE',
        '$locationProvider',
        function ($stateProvider, $urlRouterProvider, $httpProvider, START_ROUTE, $locationProvider) {
            $httpProvider.interceptors.push('HttpRequestInterceptor');
            $httpProvider.interceptors.push('HttpResponseErrorInterceptor');

            $locationProvider.html5Mode({
                enabled: true,
            });

            // for correct work of sidebar menu highlight we need to have
            // parent url similar with children without one step. for example :
            // parent '/report-management'
            // children '/report-management/edit'
            $stateProvider
                .state('index', {
                    abstract: true,
                    data: {
                        pageTitle: 'Home',
                    },
                    views: {
                        root: {
                            templateUrl: 'views/index.html',
                        },
                    },
                    resolve: {
                        oCurrentUser: ['Auth', Auth => Auth.getCurrentUser()],
                    }
                })
                .state('index.import-log', {
                    url: '/:partnerSlug/import-log',
                    data: {
                        pageTitle: 'Import Log',
                        ACLs: ['ROLE_USE_FILE_MANAGER', 'ROLE_SUPER_ADMIN'],
                    },
                    views: {
                        body: {
                            controller: 'ImportLogController as vm',
                            templateUrl: 'views/import-log.html',
                        },
                    },
                })
                .state('index.data', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.data.upload', {
                    url: '/:partnerSlug/data-upload',
                    data: {
                        pageTitle: 'Upload Data',
                        ACLs: ['ROLE_USE_FILE_MANAGER', 'ROLE_SUPER_ADMIN'],
                    },
                    controller: 'DataUploadController as vm',
                    templateUrl: 'views/data-upload.html'
                })
                .state('index.data.column-mapping', {
                    url: '/:partnerSlug/data-upload/column-mapping',
                    data: {
                        pageTitle: 'Column Mapping',
                        ACLs: ['ROLE_USE_FILE_MANAGER', 'ROLE_SUPER_ADMIN'],
                    },
                    params: {
                        csvColumns: undefined,
                        template: undefined,
                        fileId: undefined,
                    },
                    controller: 'ColumnMappingController as vm',
                    templateUrl: 'views/column-mapping.html'
                })
                .state('auth', {
                    views: {
                        root: {
                            templateUrl: 'views/auth.html',
                        },
                    },
                    abstract: true,
                })
                .state('auth.login', {
                    url: '/:partnerSlug/login',
                    data: {
                        pageTitle: 'Login',
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                    templateUrl: 'views/login.html',
                    controller: 'LoginController as vm',
                })
                .state('auth.forgot-password', {
                    url: '/:partnerSlug/forgot-password',
                    data: {
                        pageTitle: 'Forgot Password',
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                    templateUrl: 'views/forgot-password.html',
                    controller: 'ForgotPasswordController as vm',
                })
                .state('auth.reset-password', {
                    url: '/:partnerSlug/reset-password/:resetToken',
                    data: {
                        pageTitle: 'Reset Password',
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                    templateUrl: 'views/reset-password.html',
                    controller: 'ResetPasswordController as vm',
                })
                .state('auth.activate-account', {
                    url: '/:partnerSlug/activate-account/:activateToken',
                    data: {
                        pageTitle: 'Activate Account',
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                    templateUrl: 'views/activate-account.html',
                    controller: 'ActivateAccountController as vm',
                })
                .state('auth.registration', {
                    url: '/:partnerSlug/registration',
                    data: {
                        pageTitle: 'Registration',
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                    templateUrl: 'views/registration.html',
                    controller: 'RegistrationController as vm',
                })
                .state('auth.confirm-email', {
                    url: '/:partnerSlug/confirm-email/:confirmToken',
                    data: {
                        pageTitle: 'Confirm Email',
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                    templateUrl: 'views/login.html',
                    controller: 'ConfirmEmailController as vm',
                })
                .state('index.reports', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.reports.list', {
                    url: '/:partnerSlug/reports',
                    templateUrl: 'views/reports-list.html',
                    controller: 'ReportsListController as vm',
                    data: {
                        pageTitle: 'Reports',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORTING']
                    },
                })
                .state('report', {
                    views: {
                        root: {
                            templateUrl: 'views/report-template.html',
                        },
                    },
                    abstract: true,
                })
                .state('report.details', {
                    url: '/:partnerSlug/reports/:id',
                    templateUrl: 'views/report-details.html',
                    controller: 'ReportDetailsController as vm',
                    data: {
                        pageTitle: 'Report details',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORTING']
                    },
                })
                .state('report-detail-new-tab', {
                    url: '/:partnerSlug/reports/new-tab/:id',
                    views: {
                        root: {
                            templateUrl: 'views/report-details-new-tab.html',
                            controller: 'ReportDetailsNewTabController as vm',
                        },

                    },
                    resolve: {
                        oCurrentUser: ['Auth', Auth => Auth.getCurrentUser()],
                    },
                    data: {
                        pageTitle: 'Report details',

                    },
                })
                .state('index.report-management', {
                    data: {
                        ACLs: ['ROLE_SUPER_ADMIN'],
                    },
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.report-management.categories-list', {
                    url: '/:partnerSlug/categories-management',
                    templateUrl: 'views/categories-management-list.html',
                    controller: 'CategoriesManagementListController as vm',
                    data: {
                        pageTitle: 'Categories List',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL'],
                    },
                })
                .state('index.report-management.categories-edit', {
                    url: '/:partnerSlug/categories-management/edit/:id',
                    templateUrl: 'views/categories-management-edit.html',
                    controller: 'CategoriesManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit Category',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL'],
                    },
                })
                .state('index.report-management.categories-add', {
                    url: '/:partnerSlug/categories-management/add',
                    templateUrl: 'views/categories-management-add.html',
                    controller: 'CategoriesManagementAddController as vm',
                    data: {
                        pageTitle: 'Add Category',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL'],
                    },
                })
                .state('index.report-management.reports-list', {
                    url: '/:partnerSlug/reports-management',
                    templateUrl: 'views/reports-management-list.html',
                    controller: 'ReportsManagementListController as vm',
                    data: {
                        pageTitle: 'Reports List',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL',
                            'ROLE_USE_REPORT_MANAGEMENT'],
                    },
                })
                .state('index.report-management.reports-edit', {
                    url: '/:partnerSlug/reports-management/edit/:id',
                    templateUrl: 'views/reports-management-edit.html',
                    controller: 'ReportsManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit Report',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL',
                            'ROLE_USE_REPORT_MANAGEMENT'],
                    },
                })
                .state('index.report-management.reports-add', {
                    url: '/:partnerSlug/reports-management/add',
                    templateUrl: 'views/reports-management-add.html',
                    controller: 'ReportsManagementAddController as vm',
                    data: {
                        pageTitle: 'Add Category',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL'],
                    },
                })
                .state('index.users-management', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.users-management.users-list', {
                    url: '/:partnerSlug/users-management',
                    templateUrl: 'views/users-management-list.html',
                    controller: 'UsersManagementListController as vm',
                    data: {
                        pageTitle: 'User Management List',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.users-list-pending', {
                    url: '/:partnerSlug/users-management/pending',
                    templateUrl: 'views/users-management-list-pending.html',
                    controller: 'UsersManagementListPendingController as vm',
                    data: {
                        pageTitle: 'User Management Pending List',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.users-list-unconfirmed', {
                    url: '/:partnerSlug/users-management/unconfirmed',
                    templateUrl: 'views/users-management-list-unconfirmed.html',
                    controller: 'UsersManagementListUnconfirmedController as vm',
                    data: {
                        pageTitle: 'User Management Unconfirmed List',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.users-edit', {
                    url: '/:partnerSlug/users-management/edit/:id',
                    templateUrl: 'views/users-management-edit.html',
                    controller: 'UsersManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit User',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.users-add', {
                    url: '/:partnerSlug/users-management/add',
                    templateUrl: 'views/users-management-add.html',
                    controller: 'UsersManagementAddController as vm',
                    data: {
                        pageTitle: 'Add User',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.userlog-list', {
                    url: '/:partnerSlug/userlog-management',
                    templateUrl: 'views/userlog-management-list.html',
                    controller: 'UsersLogListController as vm',
                    data: {
                        pageTitle: 'Users Log List',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.powerbiuser-list', {
                    url: '/:partnerSlug/powerbiuser-management',
                    templateUrl: 'views/powerbiuser-management-list.html',
                    controller: 'PowerBiUsersListController as vm',
                    data: {
                        pageTitle: 'PowerBI Users List',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.powerbiuser-add', {
                    url: '/:partnerSlug/powerbiuser-management/add',
                    templateUrl: 'views/powerbiuser-management-add.html',
                    controller: 'PowerBiUserManagementAddController as vm',
                    data: {
                        pageTitle: 'Add PowerBI User',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.powerbiuser-edit', {
                    url: '/:partnerSlug/powerbiuser-management/edit/:id',
                    templateUrl: 'views/powerbiuser-management-edit.html',
                    controller: 'PowerBiUserManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit PowerBI User',
                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.roles-list', {
                    url: '/:partnerSlug/roles-management',
                    templateUrl: 'views/roles-management-list.html',
                    controller: 'RolesManagementListController as vm',
                    data: {
                        pageTitle: 'Roles Management List',
                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.roles-edit', {
                    url: '/:partnerSlug/roles-management/edit/:id',
                    templateUrl: 'views/roles-management-edit.html',
                    controller: 'RolesManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit Role',
                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.roles-edit-all', {
                    url: '/:partnerSlug/roles-management/edit-all',
                    templateUrl: 'views/roles-management-edit-all.html',
                    controller: 'RolesManagementEditAllController as vm',
                    data: {
                        pageTitle: 'Manage Roles',
                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.users-management.roles-add', {
                    url: '/:partnerSlug/roles-management/add',
                    templateUrl: 'views/roles-management-add.html',
                    controller: 'RolesManagementAddController as vm',
                    data: {
                        pageTitle: 'Add Role',
                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.profile', {
                    views: {
                        body: {
                            templateUrl: 'views/profile.html',
                            controller: 'ProfileController as vm',
                        },
                    },
                    abstract: true,
                })
                .state('index.profile.edit', {
                    url: '/:partnerSlug/profile/edit',
                    templateUrl: 'views/profile-edit.html',
                    controller: 'ProfileEditController as vm',
                    data: {
                        pageTitle: 'Edit Profile',
                        ACLs: ['ROLE_EDIT_OWN_PROFILE', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.profile.change-password', {
                    url: '/:partnerSlug/profile/change-password',
                    templateUrl: 'views/change-password.html',
                    controller: 'ChangePasswordController as vm',
                    data: {
                        pageTitle: 'Change Password',
                        ACLs: ['ROLE_EDIT_OWN_PROFILE', 'ROLE_SUPER_ADMIN'],
                    },
                })
                .state('index.power-bi-workspace-management', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.power-bi-workspace-management.list', {
                    url: '/:partnerSlug/power-bi-workspace-management',
                    templateUrl: 'views/power-bi-workspace-management-list.html',
                    controller: 'PowerBIWorkspaceManagementListController as vm',
                    data: {
                        pageTitle: 'Power BI Workspaces',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                    },
                })
                .state('index.power-bi-workspace-management.add', {
                    url: '/:partnerSlug/power-bi-workspace-management/add',
                    templateUrl: 'views/power-bi-workspace-management-add.html',
                    controller: 'PowerBIWorkspaceManagementAddController as vm',
                    data: {
                        pageTitle: 'Create Power BI Workspace',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                    },
                })
                .state('index.power-bi-workspace-management.edit', {
                    url: '/:partnerSlug/power-bi-workspace-management/edit/:id',
                    templateUrl: 'views/power-bi-workspace-management-edit.html',
                    controller: 'PowerBIWorkspaceManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit Power BI Workspace',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                        },
                })
                .state('index.application-database-management', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.application-database-management.list', {
                    url: '/:partnerSlug/application-databases-management',
                    templateUrl: 'views/application-database-management-list.html',
                    controller: 'ApplicationDatabaseManagementListController as vm',
                    data: {
                        pageTitle: 'Application Databases',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                    },
                })
                .state('index.application-database-management.add', {
                    url: '/:partnerSlug/application-databases-management/add',
                    templateUrl: 'views/application-database-management-add.html',
                    controller: 'ApplicationDatabaseManagementAddController as vm',
                    data: {
                        pageTitle: 'Add New Application Database',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                    },
                })
                .state('index.application-database-management.edit', {
                    url: '/:partnerSlug/application-databases-management/edit/:id',
                    templateUrl: 'views/application-database-management-edit.html',
                    controller: 'ApplicationDatabaseManagementEditController as vm',
                    data: {
                        pageTitle: 'Edit Application Database',
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                    },
                })
                .state('index.partner-mngt', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.partner-mngt.list', {
                    url: '/:partnerSlug/partner-management/list',
                    templateUrl: 'views/partner-mngt-list.html',
                    controller: 'PartnerMngtListController as vm',
                    data: {
                        pageTitle: 'Partner Management',
                        ACLs: ['ROLE_SUPER_ADMIN']
                    },
                })
                .state('index.project-mngt', {
                    views: {
                        body: {
                            template: '<ui-view></ui-view>',
                        },
                    },
                    abstract: true,
                })
                .state('index.project-mngt.list', {
                    url: '/:partnerSlug/project-management/list',
                    templateUrl: 'views/project-mngt-list.html',
                    controller: 'ProjectMngtController as vm',
                    data: {
                        pageTitle: 'Project Management',
                        ACLs: ['ROLE_SUPER_ADMIN']
                    },
                })
                .state('public-partner', {
                    views: {
                        root: {
                            templateUrl: 'views/public-partner.html',
                        },
                    },
                    abstract: true,
                })
                .state('public-partner.dashboard', {
                    url: '/:partnerSlug/dashboard/:reportId',
                    templateUrl: 'views/public-partner-report.html',
                    controller: 'PublicPartnerReportController as vm',
                    data: {
                        pageTitle: 'Partner Dashboard',
                        ACLs: []
                    },
                    resolve: {
                        oCurrentPartner: ['Partner', '$stateParams', (Partner, $stateParams) =>
                            Partner.getPartnerByLsug($stateParams.partnerSlug)],
                    },
                });


            $urlRouterProvider.otherwise(($injector) => {
                $injector.get('$state').go(START_ROUTE);
            });
        },
    ])
    .run([
        '$rootScope',
        '$window',
        '$state',
        '$timeout',
        'Settings',
        'Auth',
        'LIVE_RELOADING',
        'RolesManager',
        'START_ROUTE',
        'FormManager',
        'VERSION',
        function ($rootScope, $window, $state, $timeout, Settings, Auth, LIVE_RELOADING, RolesManager, START_ROUTE, FormManager, VERSION) {
            $rootScope.$state = $state; // state to be accessed from view
            $rootScope.Settings = Settings; // settings to be accessed from view
            $rootScope.RolesManager = RolesManager; // allow for views
            $rootScope.START_ROUTE = START_ROUTE;
            $rootScope.FormManager = FormManager;
            $rootScope.bPageContentPaddingTop = true;
            $rootScope.version = VERSION;
	    $rootScope.date = new Date();

            // for correct work of sidebar menu highlight we need to have
            // parent url similar with children without one step. for example :
            // parent '/report-management'
            // children '/report-management/edit'
            $rootScope.aSidebarMenuItems = [
                {
                    title: 'File manager',
                    icon: 'home',
                    data: {
                        ACLs: ['ROLE_USE_FILE_MANAGER', 'ROLE_SUPER_ADMIN']
                    },
                    child: [
                        {
                            title: 'Upload data',
                            icon: 'upload',
                            state: 'index.data.upload',
                            data: {
                                ACLs: ['ROLE_USE_FILE_MANAGER', 'ROLE_SUPER_ADMIN']
                            },
                        },
                        {
                            title: 'Import log',
                            icon: 'list',
                            state: 'index.import-log',
                            data: {
                                ACLs: ['ROLE_USE_FILE_MANAGER', 'ROLE_SUPER_ADMIN']
                            },
                        }
                    ],
                },
                {
                    title: 'System settings',
                    icon: 'cog',
                    data: {
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL',
                            'ROLE_USE_REPORT_MANAGEMENT',
                            'ROLE_USE_USER_MANAGEMENT', 'ROLE_USE_ROLES_MANAGEMENT']
                    },
                    child: [
                        {
                            title: 'Report management',
                            icon: 'bar-chart',
                            data: {
                                ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL',
                                    'ROLE_USE_REPORT_MANAGEMENT']
                            },
                            child: [
                                {
                                    title: 'Reports',
                                    icon: 'bar-chart',
                                    state: 'index.report-management.reports-list',
                                    data: {
                                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL',
                                            'ROLE_USE_REPORT_MANAGEMENT']
                                    },
                                },
                                {
                                    title: 'Categories',
                                    icon: 'bar-chart',
                                    state: 'index.report-management.categories-list',
                                    data: {
                                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL']
                                    },
                                }
                            ],
                        },
                        {
                            title: 'Users and roles',
                            icon: 'user',
                            data: {
                                ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN']
                            },
                            child: [
                                {
                                    title: 'User management',
                                    icon: 'user',
                                    state: 'index.users-management.users-list',
                                    data: {
                                        ACLs: ['ROLE_USE_USER_MANAGEMENT', 'ROLE_SUPER_ADMIN']
                                    },
                                },
				                {
                                    title: 'PowerBI Users',
                                    icon: 'user',
                                    state: 'index.users-management.powerbiuser-list',
                                    data: {
                                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN']
                                    },
				                },
                                {
                                    title: 'Role management',
                                    icon: 'user',
                                    state: 'index.users-management.roles-list',
                                    data: {
                                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN']
                                    },
                                },
                                {
                                    title: 'User logs',
                                    icon: 'user',
                                    state: 'index.users-management.userlog-list',
                                    data: {
                                        ACLs: ['ROLE_USE_ROLES_MANAGEMENT', 'ROLE_SUPER_ADMIN']
                                    },
                                }
                            ],
                        },
                        {
                            title: 'Database Management',
                            icon: 'bar-chart',
                            data: {
                                ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                            },
                            child: [
                                {
                                    title: 'PowerBI Workspaces',
                                    state: 'index.power-bi-workspace-management.list',
                                    data: {
                                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                                    },
                                },
                                {
                                    title: 'Application Databases',
                                    state: 'index.application-database-management.list',
                                    data: {
                                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_DATABASE_MANAGEMENT']
                                    },
                                }
                            ]
                        },
                        {
                            title: 'Partner Management',
                            icon: 'fa fa-thumbs-o-up',
                            state: 'index.partner-mngt.list',
                            data: {
                                ACLs: ['ROLE_SUPER_ADMIN']
                            },
                        },
                        {
                            title: 'Project Management',
                            icon: 'fa fa-thumbs-o-up',
                            state: 'index.project-mngt.list',
                            data: {
                                ACLs: ['ROLE_SUPER_ADMIN']
                            },
                        },
                    ],
                },
                {
                    title: 'Reports',
                    icon: 'bar-chart',
                    data: {
                        ACLs: ['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORTING']
                    },
                    state: 'index.reports.list',
                },
            ];

            $rootScope.fnLogout = () => { // allow for views
                Auth.logout();
                $state.go('auth.login', { partnerSlug: $rootScope.sPartnerSlug });
            };

            // prevent close/reload for pages with dirty form
            $(window).bind('beforeunload', () => (FormManager.checkWatchedDirty()) ? 'All unsaved data will be lost!' : undefined);

            if (LIVE_RELOADING.enable) {
                const s = document.createElement('script');
                s.src = LIVE_RELOADING.url;
                $('head').append(s);
            }

            $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
                if (FormManager.preventLeave(event)) {
                    // use timeout for trigger hide loader after $stateChangeStart
                    $timeout(() => {
                        $rootScope.$broadcast('stateChangePreventedByFormManager', event);
                    }, 0);
                    return;
                }

                const aACLs = _.get(toState, 'data.ACLs');

                if (Array.isArray(aACLs) && aACLs.length) {
                    Auth.getCurrentUser()
                        .then(() => {
                            if (RolesManager.checkMany(aACLs, 'OR') || toState.name === START_ROUTE) {
                                if (toParams.partnerSlug !== $rootScope.sPartnerSlug) {
                                    toParams.partnerSlug = $rootScope.sPartnerSlug;
                                    $state.go(toState, toParams);
                                }
                                return;
                            }
                            $state.go(START_ROUTE, { partnerSlug: $rootScope.sPartnerSlug });
                        });
                }
            });
        },
    ]);

angular.module('AlumniApp')
    .constant('ACCESS_TOKEN_LS_KEY', 'accessToken')
    .constant('ACCESS_TOKEN_HEADER_NAME', 'Authorization')
    .constant('START_ROUTE', 'index.reports.list')
    .constant('ALUMNI_DISTRICT_ID', 'ALUMNI_DISTRICT_ID')
    .constant('REPORT_PLACEMENTS', [
        { name: 'Reports', value: true },
        { name: 'Other Pages', value: false }
    ])
    .constant('REPORT_PAGES', [
        { code: 'STUDENT_PROFILE_MY_APP', name: 'Student Profile: My Applications' }
    ])
    .constant('MAIN_SLUG', 'main')
    .constant('VERSION', '210530-46');

angular.module("AlumniApp")
    .constant("API_SETTINGS", {
      ENDPOINT: "https://app.safalapps.com/api",
      VERSION: "v1"
    })
    .constant("LIVE_RELOADING", {
        url: "//localhost:35729/livereload.js",
        enable: false
    });

angular.module('AlumniApp')
    .factory('UserResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/users/:id`, {}, {
                getForTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/users`
                },
                getForActiveTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/users`
                },
                getForPendingTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/users/pending`
                },
                approveUser: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/users/approve/:id`
                },
                declineUser: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/users/disapprove/:id`
                },
                getById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/users/:id`
                },
                addUser: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/users`
                },
                updateUser: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/users/:id`
                },
                deleteUser: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/users/:id`
                },
                // User authorization by username & password
                login: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/login`
                },
                profile: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/users/profile`
                },
                updateProfile: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/users/profile`
                },
                forgotPassword: {
                    method: 'POST',
                    isArray: false,
                    url: `${API_SETTINGS.ENDPOINT}/resetting/request`
                },
                resetPassword: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/resetting/reset/:resetToken`
                },
                activateAccount: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/resetting/reset/:activateToken`
                },
                changePassword: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/users/change-password`
                },
                registration: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/registration`
                },
                confirmEmail: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/confirm-email/:confirmToken`
                },
                confirmEmailFromAdmin: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/users/confirm-email/:id`
                },
                getForUnconfirmedTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/users/unconfirmed`
                },
                inviteUserFromStudent: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/users/invite-from-student/:studentId`
                },
                reInviteUserFromStudent: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/users/re-invite-from-student/:studentId`
                },
                uploadOwnAvatar: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/users/upload-own-avatar`
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('DataTemplatesResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/getTypeOfCsvTemplates`, {}, {
                getTemplatesTypes: {
                    method: 'GET'
                },
                mapAndConvertFile: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/mapAndConvertFile`
                },
                upload: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/uploadCsvFile`
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('ReportResource', [
        '$resource',
        'API_SETTINGS',
        ($resource, API_SETTINGS) =>
            $resource('', {}, {
                getListForManagement: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/management`
                },
                getByIdForManagement: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/management/:id`
                },
                addReport: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/reports/management`
                },
                updateReport: {
                    method: 'POST',
                    headers: {
                        'X-HTTP-Method-Override': 'PATCH'
                    },
                    url: `${API_SETTINGS.ENDPOINT}/reports/management/:id`
                },
                deleteReport: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/reports/management/:id`
                },
                showById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/reporting/show/:id`
                },
                getForStudents: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/reporting/students/:studentId`
                },
                getListForReporting: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/reporting`
                },
                searchAuthors: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/search-authors`,
                    isArray: true
                },
                getPublicBySlug: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/reports/common/:slug/:reportId`,
                }
            })
    ]);

angular.module('AlumniApp')
    .factory('LogCsvResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/log_csv`, {}, {
                total: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/log_csv/total`
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('CategoryResource', [
        '$resource',
        'API_SETTINGS',
        ($resource, API_SETTINGS) =>
            $resource(`${API_SETTINGS.ENDPOINT}/categories/:id`, {}, {
                getForTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/categories`
                },
                getById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/categories/:id`
                },
                addCategory: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/categories`
                },
                updateCategory: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/categories/:id`
                },
                deleteCategory: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/categories/:id`
                },
                getAll: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/categories/all`,
                    isArray: true
                },
                getAllowed: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/categories/allowed`,
                    isArray: true
                },
            })
    ]);

angular.module('AlumniApp')
    .factory('TagResource', [
        '$resource',
        'API_SETTINGS',
        ($resource, API_SETTINGS) =>
            $resource(`${API_SETTINGS.ENDPOINT}/tags/:id`, {}, {
                getAll: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/tags/search`,
                    isArray: true
                }
            })
    ]);

angular.module('AlumniApp')
    .factory('PartnerResource', [
        '$resource',
        'API_SETTINGS',
        ($resource, API_SETTINGS) =>
            $resource(`${API_SETTINGS.ENDPOINT}/partners/common/all`, {}, {
                getAll: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/partners/common/all`,
                    isArray: true
                },
                getAllowed: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/partners/allowed`,
                    isArray: true
                },
                getWithPagination: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/partners`,
                },
                create: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/partners`,
                },
                edit: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/partners/:id`,
                    headers: {
                        'X-HTTP-Method-Override': 'PATCH'
                    },
                },
                delete: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/partners/:id`,
                },
                getBySlug: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/partners/common/slug/:slug`,
                }
            })
    ]);

angular.module('AlumniApp')
    .factory('GroupNRoleResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/groups/:id`, {}, {
                getRoles: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/roles`,
                    isArray: true
                },
                getGroups: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/groups`,
                    isArray: true
                },
                getGroupsById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/groups/:id`,
                },
                updateGroup: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/groups/:id`
                },
                addGroup: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/groups`,
                },
                deleteGroup: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/groups/:id`,
                },
                updatePermission: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/groups/change-role/:id`
                },
                getGroupsForParent: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/groups/as-parents/:groupId/by-level/:groupLvl`,
                    isArray: true
                },
                getAllowed: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/groups/allowed`,
                    isArray: true
                },
                getGroupsAsParentByLvl: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/groups/as-parents-by-lvl/:groupLvl`,
                    isArray: true
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('ProjectResource', [
        '$resource',
        'API_SETTINGS',
        ($resource, API_SETTINGS) =>
            $resource('', {}, {
                getAllByPartner: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/projects/common/by-partner/:partnerId`,
                    isArray: true
                },
                getAllowedByPartner: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/projects/allowed/by-partner/:partnerId`,
                    isArray: true
                },
                getWithPagination: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/projects`,
                },
                create: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/projects`,
                },
                getById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/projects/:id`,
                },
                edit: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/projects/:id`,
                },
                delete: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/projects/:id`,
                },
            })
    ]);

angular.module('AlumniApp')
    .factory('FeedbackResource', [
        '$resource',
        'API_SETTINGS',
        ($resource, API_SETTINGS) =>
            $resource(`${API_SETTINGS.ENDPOINT}/feedback/:id`, {}, {
                addFeedback: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/feedback`
                }
            })
    ]);

angular.module('AlumniApp')
    .factory('PowerBIWorkspaceResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/power-bi-workspace/:id`, {}, {
                getForTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/power-bi-workspace`
                },
                add: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/power-bi-workspace`
                },
                getById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/power-bi-workspace/:id`
                },
                update: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/power-bi-workspace/:id`
                },
                delete: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/power-bi-workspace/:id`
                },
                getAll: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/power-bi-workspace/all`,
                    isArray: true
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('ApplicationDatabaseResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/application-database/:id`, {}, {
                getAll: {
			method: 'GET',
			url: `${API_SETTINGS.ENDPOINT}/application-database/common/all`,
			isArray: true
		},
		getForTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/application-database`
                },
                add: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/application-database`
                },
                getById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/application-database/:id`
                },
                update: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/application-database/:id`
                },
                delete: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/application-database/:id`
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('ApplicationAccessResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/application-access/:id`, {}, {
                getAllowedDistricts: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/application-access/allowed-districts`,
                    isArray: true
                },
                getAllowedCampuses: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/application-access/allowed-campuses-by-district/:districtId`,
                    isArray: true
                },
                getAllowedProjects: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/application-access/allowed-projects`,
                    isArray: true
                }
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('PowerBiUserResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/powerbiusers/:id`, {}, {
                getForTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/powerbiusers`
                },
                getById: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/powerbiusers/:id`
                },
                add: {
                    method: 'POST',
                    url: `${API_SETTINGS.ENDPOINT}/powerbiusers`
                },
                update: {
                    method: 'PATCH',
                    url: `${API_SETTINGS.ENDPOINT}/powerbiusers/:id`
                },
                delete: {
                    method: 'DELETE',
                    url: `${API_SETTINGS.ENDPOINT}/powerbiusers/:id`
                },
		getAll: {
	            method: 'GET',
		    url: `${API_SETTINGS.ENDPOINT}/powerbiusers/all`,
		    isArray: true
		}
            });
        }
    ]);

angular.module('AlumniApp')
    .factory('UserLogResource', [
        '$resource',
        'API_SETTINGS',
        function ($resource, API_SETTINGS) {
            return $resource(`${API_SETTINGS.ENDPOINT}/userslog/:id`, {}, {
                getForTable: {
                    method: 'GET',
                    url: `${API_SETTINGS.ENDPOINT}/userslog`
                },
		getAll: {
	            method: 'GET',
		    url: `${API_SETTINGS.ENDPOINT}/userslog/all`,
		    isArray: true
		}
            });
        }
    ]);

angular.module("AlumniApp")
    .factory('Settings', [
        function () {
            return {
                layout: {
                    pageContentWhite: true, // set page content layout
                    pageBodySolid: false // solid body color state
                },

                //Use absolute path for HTML5 mode
                assetsPath: '/assets/theme',
                globalPath: '/assets/theme/global',
                layoutPath: '/assets/theme/layouts/layout'
            };
        }
    ]);

angular.module('AlumniApp')
    .factory('Auth', [
        'ACCESS_TOKEN_LS_KEY',
        'UserResource',
        '$q',
        '$rootScope',
        'MAIN_SLUG',
        function (ACCESS_TOKEN_LS_KEY, UserResource, $q, $rootScope, MAIN_SLUG) {
            // for allow from views
            $rootScope.oCurrentUser = null;

            let oLastPromise = null;

            function fnGetCurrentUser(bClearCache) {
                if (bClearCache || !oLastPromise) {
                    oLastPromise = UserResource.profile().$promise
                        .then((oRes) => {
                            $rootScope.oCurrentUser = oRes;
                            $rootScope.sPartnerSlug = _.get(oRes, 'partner.slug', MAIN_SLUG);
                            return $rootScope.oCurrentUser;
                        })
                        .catch((oError) => {
                            $rootScope.oCurrentUser = null;
                            oLastPromise = null;
                            throw oError;
                        });
                    return oLastPromise;
                }

                return oLastPromise;
            }

            return {
                getCurrentUser: fnGetCurrentUser,

                /**
                 * @param oData
                 * {
                 *  password: String,
                 *  username: String
                 * }
                 */
                login(oData) {
                    $rootScope.oCurrentUser = null;
                    localStorage.removeItem(ACCESS_TOKEN_LS_KEY);

                    return UserResource.login({}, oData).$promise
                        .then((oRes) => {
                            $rootScope.oCurrentUser = oRes.user;
                            localStorage.setItem(ACCESS_TOKEN_LS_KEY, oRes.token);
                            return $rootScope.oCurrentUser;
                        });
                },
                forgotPassword(oData) {
                    return UserResource.forgotPassword({}, oData).$promise
                        .then(oRes => oRes);
                },
                resetPassword(oData, sResetToken) {
                    return UserResource.resetPassword({
                        resetToken: sResetToken,
                    }, oData, null, null).$promise
                        .then(oRes => oRes);
                },
                activateAccount(oData, sActivateToken) {
                    return UserResource.activateAccount({
                        activateToken: sActivateToken,
                    }, oData, null, null).$promise
                        .then(oRes => oRes);
                },
                logout() {
		            $rootScope.oCurrentUser = null;
                    oLastPromise = null;
                    localStorage.removeItem(ACCESS_TOKEN_LS_KEY);
                    return $q.when();
                },
                registration(oData) {
                    return UserResource.registration({}, oData).$promise
                        .then(oRes => oRes);
                },
                confirmEmail(sConfirmToken) {
                    return UserResource.confirmEmail({
                        confirmToken: sConfirmToken
                    }, null).$promise
                        .then(oRes => oRes);
                }
            };
        },
    ]);

angular.module('AlumniApp')
    .factory('UrlParser', [
        function () {
            const oParser = document.createElement('a');
            return function (sUrl) {
                oParser.href = sUrl;

                const oParams = {
                    href: oParser.href,
                    protocol: oParser.protocol,
                    hash: oParser.hash,
                    search: oParser.search,
                    pathname: oParser.pathname,
                    host: oParser.host,
                    hostname: oParser.hostname,
                    port: oParser.port
                };

                // pathname return path without '/' in IE (maybe in some other browser too)
                if (oParams.pathname[0] != '/') {
                    oParams.pathname = `/${oParams.pathname}`;
                }
                if (oParams.pathname[oParams.pathname.length - 1] == '/') {
                    oParams.pathname = oParams.pathname.slice(0, -1);
                }

                return oParams;
            };
        }
    ]);

angular.module('AlumniApp')
    .factory('HttpRequestInterceptor', [
        'UrlParser',
        'ACCESS_TOKEN_LS_KEY',
        function (UrlParser, ACCESS_TOKEN_LS_KEY) {
            return {
                request(oConfig) {
                    oConfig.headers.Authorization = `Bearer ${localStorage.getItem(ACCESS_TOKEN_LS_KEY)}`;

                    const fnFormData = (data) => {
                        const formData = new FormData();
                        _.each(data, (value, key) => {
                            // add keys name to this exception if you need to add array to form data
                            if (key == 'tags') {
                                for (let i = 0; i < value.length; i++) {
                                    formData.append('tags[][name]', value[i].name);
                                }
                                if (value.length == 0) {
                                    formData.append('tags', '');
                                }
                            } else {
                                formData.append(key, value);
                            }
                        });
                        return formData;
                    };

                    // paths for multiparts
                    const aPaths = [
                        '/api/uploadCsvFile',
                        '/api/reports/management',
                        '/reports/management',
                        '/api/feedback',
                        new RegExp('\/api\/reports\/management\/[0-9]*$'),
                        '/api/users/upload-own-avatar',
                        '/api/partners',
                        '/partners',
                        '/users/upload-own-avatar',
                        new RegExp('/api/logout/\[0-9]*$'),
                        new RegExp('\/api\/partners\/[0-9]*$'),
                        new RegExp('\/partners\/[0-9]*$'),
                    ];

                    const sPath = UrlParser(oConfig.url).pathname;
                    oConfig.headers['Content-Type'] = 'application/json';

                    for (let i = 0; i < aPaths.length; i++) {
                        if (aPaths[i] instanceof RegExp) {
                            if (aPaths[i].test(sPath)) {
                                oConfig.headers['Content-Type'] = undefined;
                                oConfig.data = fnFormData(oConfig.data);
                                break;
                            }
                        } else if (aPaths[i] == sPath) {
                            oConfig.headers['Content-Type'] = undefined;
                            oConfig.data = fnFormData(oConfig.data);
                            break;
                        }
                    }

                    return oConfig;
                },
            };
        }],
    );

angular.module('AlumniApp')
    .factory('HttpResponseErrorInterceptor', [
        '$q',
        '$injector',
        function ($q, $injector) {
            return {
                responseError(rejection) {
                    if (rejection.status === 401) {
                        const aAllowed = [
                            'auth.login',
                            'auth.forgot-password',
                            'auth.reset-password',
                            'auth.activate-account',
                            'auth.registration',
                            'auth.confirm-email'
                        ];

                        if (!_.includes(aAllowed, $injector.get('$state').current.name)) {
                            $injector.get('$state').go('auth.login');
                            $injector.get('Auth').logout();
                        }
                    }

                    return $q.reject(rejection);
                }
            };
        }]
    );


class Toaster {
    constructor(ErrorManager, $rootScope) {
        this.$rootScope = $rootScope;
        this.ErrorManager = ErrorManager;
    }

    /**
     * @param oParams
     * {
     *      type: String
     *          success || error || info || warning
     *          default: success
     *
     *      title: String,
     *
     *      message: String
     *          required
     *
     *      options: Object,
     *          {
     *              closeButton: Boolean
     *                  default: true
     *
     *              positionClass: String
     *                  toast-top-right || toast-bottom-right || toast-bottom-left || toast-top-left ||
     *                  toast-top-center || toast-bottom-center || toast-top-full-width || toast-bottom-full-width
     *                  default: toast-top-right
     *
     *              ... http://codeseven.github.io/toastr/demo.html
     *          }
     * }
     */
    toast(oParams) {
        _.defaultsDeep(oParams, {
            type: 'success',
            options: {
                positionClass: 'toast-top-right',
                closeButton: true,
            },
        });

        toastr[oParams.type](oParams.message, oParams.title, oParams.options);
    }

    toastError(oRes) {
        const oError = this.ErrorManager.parse(oRes);
        if (oError.status === 401) return;
        this.toast({
            type: 'error',
            message: oError.message,
        });
    }

    toastParsedError(oError) {
        this.toast({
            type: 'error',
            message: _.get(oError, 'message') || 'An unknown error occurred',
        });
    }

    waterfall(aToasts) {
        if (!Array.isArray(aToasts)) {
            return;
        }

        let i = aToasts.length;
        while (i--) {
            this.toast(aToasts.pop());
        }
    }

    wait(bIsEternally) {
        const aToasts = [];

        const oWatcher = this.$rootScope.$watchCollection(() => aToasts, () => {
            this.waterfall(aToasts);
            if (!bIsEternally) {
                oWatcher();
            } // clear
        });

        return aToasts;
    }
}

Toaster.$inject = ['ErrorManager', '$rootScope'];

angular.module('AlumniApp')
    .service('Toaster', Toaster);

angular.module("AlumniApp")
    .factory("ServerError", function() {
        class ServerError {
            constructor(sMessage, iStatus, sName) {
                iStatus = iStatus || 500;
                sMessage = sMessage || 'An unknown error occurred';
                sName = sName || 'Error';

                this.data = { //imitation server error
                    message: sMessage,
                    status: iStatus,
                    name: sName
                };
            }
        }

        return ServerError
    });

class ErrorManager {
    constructor(ServerError) {
        this.ServerError = ServerError;
    }

    parse(oRes) {
        let oError = _.get(oRes, 'data.error');

        if (!oError) { oError = _.get(oRes, 'data'); }

        return {
            message: _.get(oError, 'message') || 'An unknown error occurred',
            status: _.get(oError, 'status') ||  _.get(oError, 'code') || 500,
            name: _.get(oError, 'name') || 'UnknownError',
            errors: _.get(oError, 'errors') || null,
        };
    }

    getParsedServerError() {
        return this.parse(new this.ServerError(...arguments));
    }

    serverToForm(oRes, oForm, aMessages) {
        const oError = this.parse(oRes);
        const oFields = _.get(oError, 'errors.children');

        if (oFields) {
            return fnExtract(oFields);
        }

        aMessages.push({
            message: oError.message,
            type: 'error',
        });

        function fnExtract(oFields, sParentPath) {
            if (_.isPlainObject(oFields)) {
                for (const sField in oFields) {
                    if (!oFields.hasOwnProperty(sField)) {
                        continue;
                    }

                    let sFormPath = sParentPath ? `${sParentPath}.${sField}` : sField,
                            oFormField = oForm[sFormPath],
                            oField = oFields[sField];

                    if (!oField || !_.isObject(oField)) {
                        continue;
                    }

                    // nested errors
                    fnExtract(oField.children, sFormPath);

                    if (!Array.isArray(_.get(oField, 'errors'))) {
                        continue;
                    }

                    if (!oFormField || !_.isObject(oFormField)) {
                        if (Array.isArray(aMessages)) {
                            for (let i = 0, l = oField.errors.length; i < l; i++) {
                                aMessages.push({
                                    message: `${oField.errors[i]}`,
                                    type: 'error',
                                });
                            }
                        }

                        continue;
                    }

                    oFormField.serverErrors = oField.errors;
                    oFormField.$setValidity('server', false);
                }
            }
        }
    }
}

ErrorManager.$inject = ['ServerError'];

angular.module('AlumniApp')
    .service('ErrorManager', ErrorManager);

class FormManager {
    constructor() {
        this.watchedForms = [];
    }

    setDirty(oForm) {
        angular.forEach(oForm.$error, (oField) => {
            angular.forEach(oField, (oErrorField) => {
                oErrorField.$setDirty();
            });
        });
    }

    setPristine(oForm) {
        oForm.$setPristine();
    }

    checkWatchedDirty() {
        for (let i = 0; i < this.watchedForms.length; i++) {
            const check = this.watchedForms[i].$dirty;
            if (check) {
                return true;
                break;
            }
        }
        return false;
    }

    watch($scope, sForm) {
        const fm = this;
        const fnWatcher = $scope.$watch(sForm, () => {
            fm.watchedForms.push($scope[sForm]);
            // TODO prevent memory leak
            fnWatcher();
        });
    }

    setPristineWatched() {
        this.watchedForms.forEach((oForm) => {
            oForm.$setPristine();
        });
    }

    clearWatched() {
        this.watchedForms = [];
    }

    preventLeave(event) {
        if (this.checkWatchedDirty()) {
            const bConfirm = confirm('All unsaved data will be lost!');
            if (bConfirm) {
                this.clearWatched();
            } else {
                event.preventDefault();
                return true;
            }
        }
        return false;
    }
}

FormManager.$inject = [];

angular.module('AlumniApp')
    .service('FormManager', FormManager);

class RolesManager {
    constructor($rootScope, Auth) {
        this.$rootScope = $rootScope;
        this.Auth = Auth;
    }

    setState(aData) {
        return this.Auth.getCurrentUser().then(oUser => ({
            user: oUser,
            data: aData,
        }));
    }

    checkOne(sRoleForCheck, oUser) {
        oUser = oUser || this.$rootScope.oCurrentUser;

        if (!oUser) { return false; }

        const aUserRoles = Array.isArray(_.get(oUser, 'roles')) ? _.get(oUser, 'roles') : [];

        if (!aUserRoles.length) {
            return false;
        }

        return _.includes(aUserRoles, sRoleForCheck);
    }

    checkMany(aRolesForCheck, sLogic, oUser) {
        oUser = oUser || this.$rootScope.oCurrentUser;

        if (!oUser) {
            return false;
        }

        const aUserRoles = Array.isArray(_.get(oUser, 'roles')) ? _.get(oUser, 'roles') : [];

        if (!aUserRoles.length) {
            return false;
        }

        if (typeof sLogic === 'string') {
            sLogic = sLogic.toUpperCase();
        }

        sLogic = sLogic === 'AND' ? sLogic : 'OR';

        if (sLogic === 'OR') {
            for (let i = 0, l = aRolesForCheck.length; i < l; i++) {
                if (_.includes(aUserRoles, aRolesForCheck[i])) { return true; }
            }

            return false;
        }

        if (sLogic === 'AND') {
            for (let i = 0, l = aRolesForCheck.length; i < l; i++) {
                if (!_.includes(aUserRoles, aRolesForCheck[i])) {
                    return false;
                }
            }

            return true;
        }

        return false;
    }
}

RolesManager.$inject = ['$rootScope', 'Auth'];

angular.module('AlumniApp')
    .service('RolesManager', RolesManager);

angular.module('AlumniApp')
    .service('Debounce', [
        '$q',
        function ($q) {
            function fnWrapDeferred(fn, deferred, aArguments) {
                return function () {
                    let mRet;
                    try {
                        mRet = fn(...aArguments);
                    } catch (e) {
                        return deferred.reject(e);
                    }
                    $q.when(mRet)
                        .then(deferred.resolve, deferred.reject);

                    return undefined;
                };
            }

            function fnAddCbsToDeffered(oOptions, deferred) {
                if (_.isFunction(oOptions.onError) || _.isFunction(oOptions.onSuccess)) {
                    deferred.promise.then(oOptions.onSuccess || null, oOptions.onError || null);
                }

                if (_.isFunction(oOptions.onDone)) {
                    deferred.promise.then(oOptions.onDone, oOptions.onDone);
                }
            }

            // every run returns same promise
            // every run time resets
            // also work with promises
            // returns fn, which returns same promise
            function fnGetResettable(fn, iTime, oOptions) {
                let debounced = null;
                let deferred = $q.defer();

                if (!_.isNumber(iTime)) {
                    iTime = 1000;
                }

                if (!_.isPlainObject(oOptions)) {
                    oOptions = {};
                }

                return function () {
                    _.isFunction(oOptions.beforeStart) && oOptions.beforeStart();

                    if (debounced) {
                        debounced.cancel();
                    }

                    debounced = _.debounce(fnWrapDeferred(fn, deferred, arguments), iTime);
                    debounced();

                    fnAddCbsToDeffered(oOptions, deferred);

                    if (oOptions.pristineOnDone) {
                        deferred.promise.then(() => {
                            deferred = $q.defer();
                            fnAddCbsToDeffered(oOptions, deferred);
                        }, () => {
                            deferred = $q.defer();
                            fnAddCbsToDeffered(oOptions, deferred);
                        });
                    }

                    return deferred.promise;
                };
            }

            // every run returns new promise
            // also work with promises
            // returns fn, which returns new promise
            function fnGet(fn, iTime, oOptions) {
                if (!_.isNumber(iTime)) {
                    iTime = 1000;
                }

                if (!_.isPlainObject(oOptions)) {
                    oOptions = {};
                }

                return function () {
                    _.isFunction(oOptions.beforeStart) && oOptions.beforeStart();
                    const deferred = $q.defer();

                    _.debounce(fnWrapDeferred(fn, deferred, arguments), iTime)();
                    fnAddCbsToDeffered(oOptions, deferred);

                    return deferred.promise;
                };
            }

            // run debounced
            // also work with promises
            // returns promise
            function fnRun(fn, iTime, oOptions) {
                if (!_.isNumber(iTime)) {
                    iTime = 1000;
                }

                if (!_.isPlainObject(oOptions)) {
                    oOptions = {};
                }

                _.isFunction(oOptions.beforeStart) && oOptions.beforeStart();
                const deferred = $q.defer();

                _.debounce(fnWrapDeferred(fn, deferred, arguments), iTime)();
                fnAddCbsToDeffered(oOptions, deferred);

                return deferred.promise;
            }

            return {
                getResettable: fnGetResettable,
                get: fnGet,
                run: fnRun,
            };
        },
    ]);

class Notific {
    constructor($rootScope, $templateRequest, $compile) {
        this.$rootScope = $rootScope;
        this.$templateRequest = $templateRequest;
        this.$compile = $compile;
    }

    /**
     * @param oParams
     * {
     *      template: '',
     *      templateUrl: '',
     *      scope: {},
     *      options: {}
     * }
     */

    notify(oParams) {
        let oThis = this,
                sTemplate = '';

        oParams.scope = oParams.scope ? oParams.scope : oThis.$rootScope;

        oParams.options = _.defaultsDeep(oParams.options, {
            life: 10000,
            horizontalEdge: 'bottom'
        });

        if (oParams.templateUrl) {
            return this.$templateRequest(oParams.templateUrl).then((html) => {
                const oTemplate = angular.element(html);
                sTemplate = oThis.$compile(oTemplate)(oParams.scope);
                $.notific8(sTemplate[0].outerHTML, oParams.options);
            });
        } else {
            sTemplate = oThis.$compile(oParams.template)(oParams.scope);
        }

        $.notific8(sTemplate[0].outerHTML, oParams.options);
    }
}

Notific.$inject = ['$rootScope', '$templateRequest', '$compile'];

angular.module('AlumniApp')
    .service('Notific', Notific);

angular.module('AlumniApp')
    .factory('Partner', [
        'ACCESS_TOKEN_LS_KEY',
        'PartnerResource',
        '$q',
        '$rootScope',
        '$state',
        'MAIN_SLUG',
        function (ACCESS_TOKEN_LS_KEY, PartnerResource, $q, $rootScope, $state, MAIN_SLUG) {
            // for allow from views
            $rootScope.oCurrentPartner = null;

            function fnGetPartnerByLsug(slug) {
                $rootScope.sPartnerSlug = MAIN_SLUG;
                if (slug !== MAIN_SLUG) {
                    return PartnerResource.getBySlug({ slug }).$promise
                        .then((oRes) => {
                            $rootScope.currentPartner = oRes;
                            $rootScope.sPartnerSlug = _.get(oRes, 'slug', MAIN_SLUG);
                            return $rootScope.currentPartner;
                        })
                        .catch(() => {
                            $q.defer().resolve();
                            $state.go('auth.login', { partnerSlug: MAIN_SLUG });
                        });
                }

                return null;
            }

            return {
                getPartnerByLsug: fnGetPartnerByLsug,
            };
        },
    ]);

angular.module('AlumniApp').filter('percent', () => (input) => {
    if (!input || isNaN(input) || input > 100 || input < 0) {
        return null;
    }
    return `${input}%`;
});

angular.module('AlumniApp')
    .filter('round', () => {
        return (input, precision) => {
            input = input || 0;

            if (!precision) return input;

            precision = Math.pow(10, precision);
            return Math.round(input * precision) / precision;
        };
    });

angular.module('AlumniApp').filter('cut', () => {
    return function (value, wordwise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
            let lastspace = value.lastIndexOf(' ');
            if (lastspace !== -1) {
                // Also remove . and , so its gives a cleaner result.
                if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                    lastspace--;
                }
                value = value.substr(0, lastspace);
            }
        }

        return value + (tail || ' …');
    };
});

const fileReader = function ($q) {
    const onLoad = function (reader, deferred, scope) {
        return function () {
            scope.$apply(() => {
                deferred.resolve(reader.result);
            });
        };
    };

    const onError = function (reader, deferred, scope) {
        return function () {
            scope.$apply(() => {
                deferred.reject(reader.result);
            });
        };
    };

    const onProgress = function (reader, scope) {
        return function (event) {
            scope.$broadcast('fileProgress',
                {
                    total: event.total,
                    loaded: event.loaded
                });
        };
    };

    const getReader = function (deferred, scope) {
        const reader = new FileReader();
        reader.onload = onLoad(reader, deferred, scope);
        reader.onerror = onError(reader, deferred, scope);
        reader.onprogress = onProgress(reader, scope);
        return reader;
    };

    const readAsDataURL = function (file, scope) {
        const deferred = $q.defer();

        const reader = getReader(deferred, scope);
        reader.readAsDataURL(file);

        return deferred.promise;
    };

    return {
        readAsDataUrl: readAsDataURL
    };
};

angular.module('AlumniApp').factory('fileReader',
    ['$q', fileReader]);

angular.module('AlumniApp').directive('ngFileSelect', () => ({
    link($scope, el) {
        el.bind('change', (e) => {
            $scope.file = (e.srcElement || e.target).files[0];
            $scope.getFile();
        });
    }

}));

angular.module('AlumniApp')

    /**
     * @usage:
     * template example: <alert-danger error="Object"></alert-danger>
     */
    .directive('alertDanger', [
        function () {
            return {
                restrict: 'EA',
                scope: {
                    error: '=error'
                },
                link(scope) {
                    scope.fnHideError = function () {
                        scope.error = null;
                    };
                },
                template: '<div ng-if="error" class="alert alert-danger alert-dismissible"> \
                            <button type="button" class="close" ng-click="fnHideError()"> \
                                <span>×</span> \
                                <span class="sr-only">Close</span> \
                            </button> \
                            <div> \
                                <span ng-bind="error.message || \'An unknown error occurred\'"></span> \
                            </div> \
                           </div>'
            };
        }
    ])

    // Handle global LINK click
    .directive('a', () => ({
        restrict: 'E',
        link(scope, elem, attrs) {
            if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                elem.on('click', (e) => {
                    e.preventDefault(); // prevent link click for above criteria
                });
            }
        }
    }))

    // Handle Dropdown Hover Plugin Integration
    .directive('dropdownMenuHover', () => ({
        link(scope, elem) {
            elem.dropdownHover();
        }
    }));


/**
 * this directive is needed just to reset error when user change input
 * <input server-error></input>
 */
angular.module('AlumniApp')
    .directive('serverValidationForm', [
        '$timeout',
        $timeout => ({
            restrict: 'A',
            require: '^form',
            link(scope, element, attrs, formCtrl) {
                function fnValidate(oValue) {
                    return formCtrl.$submitted === true && oValue.serverErrors ? false : true;
                }

                function fnIsValid(formCtrl) {
                    angular.forEach(formCtrl, (oValue) => {
                        // We skip non-form and non-inputs
                        if (!oValue || oValue.$dirty === undefined) {
                            return;
                        }

                        // Recursively applying same method on all forms included in the form
                        if (oValue.$addControl) { return fnIsValid(oValue); }

                        oValue.$parsers.unshift((viewValue) => {
                            oValue.$setValidity('server', fnValidate(oValue)); // default set true
                            return viewValue;
                        });

                        oValue.$formatters.unshift((modelValue) => {
                            oValue.$setValidity('server', fnValidate(oValue)); // default set true
                            return modelValue;
                        });

                        scope.$watch(() => oValue.$modelValue, () => {
                            if (oValue.serverErrors) {
                                delete oValue.serverErrors;
                                oValue.$setValidity('server', fnValidate(oValue)); // default set true
                            }
                        });
                    });
                }

                // Run in next digest cycle (need to allow the UI SELECT to initialize)
                $timeout(() => {
                    fnIsValid(formCtrl);
                }, 0);
            }
        })
    ]);

// directive for create input with only numbers in it
angular.module('AlumniApp').directive('onlyNumbers', () => ({
    restrict: 'A',
    link(scope, elm) {
        elm.on('keydown', (event) => {
            if (event.shiftKey) { event.preventDefault(); return false; }
            if ([8, 13, 27, 37, 38, 39, 40, 46].indexOf(event.which) > -1) {
                // backspace, enter, escape, arrows, del
                return true;
            } else if (event.which >= 48 && event.which <= 57) {
                // numbers
                return true;
            } else if (event.which >= 96 && event.which <= 105) {
                // numpad number
                return true;
            }
            event.preventDefault();
            return false;
        });
    }
}));


angular.module('AlumniApp').directive('format', ($filter) => {
    return {
        scope: true,
        restrict: 'A',
        require: ['ngModel'],
        link: (scope, element, attrs, ctrls) => {
            const formatFactory = {
                currency: {
                    pattern: /^[\(\-\+]?\d*,?\d*\.?\d+[\)]?$/,
                    replace: /[,\$]/g,
                    symbol: '$'
                },
                percent: {
                    pattern: /^\d+(\.\d+)?$/,
                    replace: /[,%]/g,
                    symbol: '%'
                },
            };
            const ngModelCtrl = ctrls[0];
            const thisFormat = formatFactory[attrs.format];

            // This is the toModel routine
            const parser = function (value) {
                if (!value) {
                    return undefined;
                }
                // get rid of currency indicators
                value = value.toString().replace(thisFormat.replace, '');
                // Check for parens, currency filter (5) is -5
                const removeParens = value.replace(/[\(\)]/g, '');
                // having parens indicates the number is negative
                if (value.length !== removeParens.length) {
                    value = -removeParens;
                }
                return value || undefined;
            };

            // This is the toView routine
            // the currency filter returns undefined if parse error
            const formatter = (value) => $filter(attrs.format)(parser(value)) || thisFormat.symbol || '';

            // This sets the format/parse to happen on blur/focus
            element.on('blur', function () {
                ngModelCtrl.$setViewValue(formatter(this.value));
                ngModelCtrl.$render();
            }).on('focus', function () {
                ngModelCtrl.$setViewValue(parser(this.value));
                ngModelCtrl.$render();
            });

            // Model Formatter
            ngModelCtrl.$formatters.push(formatter);
            // Model Parser
            ngModelCtrl.$parsers.push(parser);
        }
    };
});

angular.module('AlumniApp').directive('multiSelect', () => ({
    restrict: 'A',
    scope: {
        model: '=ngModel',
        disabled: '=ngDisabled',
        data: '=multiSelectData'
    },
    link(scope, element) {
        $(element).multiSelect();
        scope.$watch('model', () => {
            $(element).multiSelect('refresh');
        });
        scope.$watch('disabled', () => {
            $(element).multiSelect('refresh');
        });
        scope.$watch('data', () => {
            if (!scope.data) return;
            $(element).multiSelect('refresh');
        });
    }
}))
    .directive('alumniLoader', () => ({
        restrict: 'E',
        scope: {
            booleans: '=booleans'
        },
        replace: true,
        template: '<div class="page-spinner-bar"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
        link(scope, element) {
            const fnToggleLoader = () => {
                let bools = scope.booleans;
                let bShow = false;

                if (!_.isArray(bools)) {
                    bools = [bools];
                }

                for (let i = 0; i < bools.length; i++) {
                    if (bools[i]) {
                        bShow = true;
                        break;
                    }
                }

                if (bShow) {
                    $(element).show();
                } else {
                    $(element).hide();
                }
            };

            scope.$watch('booleans', fnToggleLoader);
        }
    }));

/**
 * move here some features from theme App, Demo, Layout
 */
angular.module('AlumniApp')

    /**
     * Metronic: Route State Load Spinner(used on page or content load)
     * @usage:
     * template example: <div ng-spinner-bar class="page-spinner-bar">
     */
    .directive('ngSpinnerBar', [
        '$rootScope',
        function ($rootScope) {
            return {
                link(scope, element) {
                    // by defult hide the spinner bar
                    element.addClass('hide'); // hide spinner bar by default

                    // display the spinner bar whenever the route changes(the content part started loading)
                    $rootScope.$on('$stateChangeStart', () => {
                        element.removeClass('hide'); // show spinner bar
                    });

                    // hide the spinner bar on rounte change success(after the content loaded)
                    $rootScope.$on('$stateChangeSuccess', () => {
                        element.addClass('hide'); // hide spinner bar
                        $('body').removeClass('page-on-load'); // remove page loading indicator
                    });

                    // handle errors
                    $rootScope.$on('$stateNotFound', () => {
                        element.addClass('hide'); // hide spinner bar
                    });

                    // handle errors
                    $rootScope.$on('$stateChangeError', () => {
                        element.addClass('hide'); // hide spinner bar
                    });

                    $rootScope.$on('stateChangePreventedByFormManager', () => {
                        element.addClass('hide');
                    });
                },
            };
        },
    ])

    /**
     * see layout.js Layout.initFooter
     */
    .directive('goTop', [
        function () {
            return {
                restrict: 'E',
                replace: true,
                template: '<div class="scroll-to-top"> \
                                <i class="icon-arrow-up"></i>\
                            </div>',
                link(scope, element) {
                    const offset = 300;
                    const duration = 500;

                    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {  // ios supported
                        $(window).bind('touchend touchcancel touchleave', function () {
                            if ($(this).scrollTop() > offset) {
                                $(element).fadeIn(duration);
                            } else {
                                $(element).fadeOut(duration);
                            }
                        });
                    } else {  // general
                        $(window).scroll(function () {
                            if ($(this).scrollTop() > offset) {
                                $(element).fadeIn(duration);
                            } else {
                                $(element).fadeOut(duration);
                            }
                        });
                    }

                    $(element).click((e) => {
                        e.preventDefault();
                        $('html, body').animate({ scrollTop: 0 }, duration);
                        return false;
                    });
                },
            };
        }],
    )

    /**
     * see setAngularJsSidebarMenuActiveLink in layout.js
     */
    .directive('sidebarMenu', [
        '$state',
        '$rootScope',
        'RolesManager',
        '$timeout',
        function ($state, $rootScope, RolesManager, $timeout) {
            return {
                scope: {
                    items: '=',
                },
                restrict: 'E',
                templateUrl: 'templates/sidebar-menu.html',
                link(scope, element) {
                    scope.fnCheckRoleACLs = fnCheckRoleACLs;

                    // decorate state of top level menu
                    scope.fnDecorateSidebarState = fnDecorateSidebarState;

                    // init when render
                    setAngularJsSidebarMenuActiveLink(); // activate selected link in the sidebar menu

                    // re init when change state
                    $rootScope.$on('$stateChangeSuccess', () => {
                        setAngularJsSidebarMenuActiveLink(); // activate selected link in the sidebar menu
                    });

                    // re init for ROLE ACLs
                    $rootScope.$watch('oCurrentUser', () => {
                        if ($rootScope.oCurrentUser) {
                            $timeout(() => {
                                setAngularJsSidebarMenuActiveLink(); // activate selected link in the sidebar menu
                            });
                        }
                    });

                    function fnDecorateSidebarState(mState) {
                        if (_.get(mState, '$$state')) {
                            if (mState.$$state.status === 1) {
                                const oUser = mState.$$state.value.user;
                                const aData = mState.$$state.value.data;
                                for (let i = 0; i < aData.length; i++) {
                                    const sAccess = _.find(oUser.roles, sRole => sRole === aData[i].role);
                                    if (sAccess) {
                                        return aData[i].state;
                                    }
                                }
                            } else {
                                return '';
                            }
                        }
                        if (typeof mState === 'string') {
                            return mState;
                        }
                        return '';
                    }

                    function fnCheckRoleACLs(oMenuItem) {
                        const aACLs = _.get(oMenuItem, 'data.ACLs');

                        if (Array.isArray(aACLs) && aACLs.length) {
                            return RolesManager.checkMany(aACLs, 'OR');
                        }

                        return true;
                    }

                    scope.clickTopLevel = (event, oItem) => {
                        const bCheckLevel = $(event.target).hasClass('level-first');
                        if (!bCheckLevel) return;
                        $('.level-first').not(`.level-first[data-title="${oItem.title}"]`).removeClass('active opened');
                        if (window.innerWidth > 991) {
                            $('.level-first').not(`.level-first[data-title="${oItem.title}"]`).removeClass('opened');
                            $(`.level-first[data-title="${oItem.title}"]`).addClass('active opened');
                        } else {
                            $(`.level-first[data-title="${oItem.title}"]`).toggleClass('active opened');
                        }
                        $rootScope.bPageContentPaddingTop = oItem.child;
                    };

                    scope.clickSubLevel = (event, oItem) => {
                        const bCheckLevel = $(event.target).hasClass('level-second');
                        if (bCheckLevel && window.innerWidth > 991) {
                            $('.level-second').removeClass('opened');
                        }
                        if (!bCheckLevel || window.innerWidth > 991) return;
                        $('.level-second').removeClass('active');
                        $(`.level-second[data-title="${oItem.title}"]`).addClass('active');
                        if (window.innerWidth < 992) {
                            $('.level-second').not(`.level-second[data-title="${oItem.title}"]`).removeClass('opened');
                            $(`.level-second[data-title="${oItem.title}"]`).toggleClass('opened');
                        }
                    };

                    /**
                     * see setAngularJsSidebarMenuActiveLink in layout.js
                     */
                    function setAngularJsSidebarMenuActiveLink() {
                        // for correct work of sidebar menu highlight we need to have
                        // parent url similar with children without one step. for example :
                        // parent '/report-management'
                        // children '/report-management/edit'
                        let url = location.pathname; // HTML5 mode
                        const menu = $(element).find('ul.nav.navbar-nav.top-screen-menu');
                        let el = menu.find(`a[ng-href="${url}"]`);

                        $('.level-first').removeClass('active opened selected in-this-item');
                        $('.level-second').removeClass('active opened');
                        $('.level-third').removeClass('active');

                        if (!el[0]) {
                            url = url.split('/').slice(0, -1).join('/');
                            el = menu.find(`a[ng-href="${url}"]`);
                        }

                        if (el.length > 1) return;

                        el.parents('li.level-third').addClass('active');
                        el.parents('li.level-second').addClass('active');
                        if (window.innerWidth < 992) {
                            el.parents('li.level-first').addClass('opened');
                            el.parents('li.level-second').addClass('opened');
                        }
                        el.parents('li.level-first').addClass('active');

                        // TODO maybe find parrent state via $state and data-state-name attribute
                        // if (!el || el.size() === 0) {
                        //     let oCurrentState = null;
                        //     const aStates = $state.get();
                        //     for (let i = 0; i < aStates.length; i++) {
                        //         if (url === $state.href(aStates[i].name, {}, {absolute: false})) {
                        //             oCurrentState = aStates[i];
                        //             break;
                        //         }
                        //     }
                        //
                        //     if (!el || el.size() === 0) {
                        //         return;
                        //     }
                        // }
                    }
                },
            };
        },
    ])

    .directive('togglerMenu', [
        function () {
            return {
                restrict: 'E',
                template: ' <a href="javascript:;" class="menu-toggler">',
                link(scope, element) {
                    $(element).click((e) => {
                        if (getViewPort().width < 992) {
                            var menu = $(".page-header .page-header-menu");
                            if (menu.is(":visible")) {
                                menu.slideUp(300);
                            } else {
                                menu.slideDown(300);
                            }

                            if ($('body').hasClass('page-header-top-fixed')) {
                                App.scrollTop();
                            }
                        }
                    });

                    function getViewPort() {
                        var e = window,
                            a = 'inner';
                        if (!('innerWidth' in window)) {
                            a = 'client';
                            e = document.documentElement || document.body;
                        }

                        return {
                            width: e[a + 'Width'],
                            height: e[a + 'Height']
                        };
                    };
                },
            };
        }],
    )

    .directive('tabMenu', [
        function () {
            return {
                restrict: 'E',
                templateUrl: function(element, attrs) {
                    return attrs.template;
                },
                link(scope, element) {
                    scope.fnCheckActiveTabs = checkActiveTab;
                    
                    function checkActiveTab(id) {
                        return $(element).find('#'+id).hasClass('active');
                    }
                }
            }
        }
    ]);

class DataUploadController {
    constructor($state, FileUploader, DataTemplatesResource, Toaster, FormManager, ErrorManager) {
        const vm = this;

        const oUploader = vm.oUploader = new FileUploader();

        vm.oSelected = {
            template: null,
            separatorId: 3,
            csv: null
        };
        vm.oTemplates = {};
        vm.bIsLoading = false;

        vm.bIsXLS = false;

        vm.fnOpenFileDialog = function () {
            $('#csv').click();
        };

        vm.fnUploadData = (oForm) => {
            let bInvalid = false;

            if (!vm.oSelected.template) {
                bInvalid = true;
            }

            if (!vm.oSelected.csv) {
                bInvalid = true;
            }

            // bInvalid = oForm.$invalid || bInvalid;

            FormManager.setDirty(oForm);

            if (bInvalid) {
                return;
            }

            if (vm.bIsLoading) {
                return;
            }

            vm.bIsLoading = true;
            DataTemplatesResource.upload({}, {
                csvTemplateId: vm.oSelected.template.template_id,
                separatorId: vm.oSelected.separatorId,
                csvFile: vm.oSelected.csv._file,
            }).$promise
                .then(oData => $state.go('index.data.column-mapping', {
                    csvColumns: oData.columns,
                    template: vm.oSelected.template,
                    fileId: oData.fileId
                }))
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        oUploader.onWhenAddingFileFailed = function () {
            vm.oSelected.csv = null;
            vm.bIsXLS = false;
        };
        oUploader.onAfterAddingFile = function (fileItem) {
            const sXls = 'application/vnd.ms-excel';
            const sXlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

            if (fileItem.file.type === sXls || fileItem.file.type === sXlsx) {
                Toaster.toast({
                    message: 'You selected xls/xlsx file. Only first sheet will be imported.',
                    type: 'warning'
                });
                vm.bIsXLS = true;
                vm.oSelected.separatorId = null;
            } else {
                vm.oSelected.separatorId = 3;
                vm.bIsXLS = false;
            }
            vm.oSelected.csv = fileItem;
        };

        DataTemplatesResource.getTemplatesTypes().$promise
            .then((oData) => {
                vm.oTemplates = oData;
            })
            .catch((oRes) => {
                Toaster.toastError(oRes);
            });
    }
}

DataUploadController.$inject = ['$state', 'FileUploader', 'DataTemplatesResource', 'Toaster', 'FormManager', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('DataUploadController', DataUploadController);

class ColumnMappingController {
    constructor($stateParams, $state, DataTemplatesResource, PartnerResource, ProjectResource, Toaster, Notific) {
        const vm = this;

        PartnerResource.getAll().$promise
            .then((oRes) => {
                vm.aAllPartners = oRes;
            })
            .catch((oRes) => {
                Toaster.toast({
                    message: oRes.message,
                    type: 'error'
                });
            });

        vm.fnGetProjects = (partnerId) => {
            ProjectResource.getAllByPartner({ partnerId }).$promise
                .then((oRes) => {
                    vm.aAllProjects = oRes;
                })
                .catch((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'error'
                    });
                });
        };

        this.sCampusType = 'list';
        this.aCsvColumns = $stateParams.csvColumns;
        this.aTemplateColumns = _.get($stateParams.template, 'columns');
        this.bIsLoading = false;
        this.aMap = [];
        this.oSelected = {
            tpl: {},
        };

        if (!Array.isArray(this.aCsvColumns) ||
            !Array.isArray(this.aTemplateColumns) ||
            !_.get($stateParams.template, 'template_id') ||
            !$stateParams.fileId) {
            return $state.go('index.data.upload');
        }

        this.fnChangeSelection = (oTemplateCol, oCsvCol, sAction, mValue) => {
            if (oTemplateCol.name === 'District ID') {
                vm.fnGetProjects(mValue);
            }
            sAction = sAction || 'link';

            let o = _.find(vm.aMap, {
                template_column_id: oTemplateCol.field_id,
            });

            if (!o) {
                o = {};
                vm.aMap.push(o);
            }

            o.template_column_id = oTemplateCol.field_id;
            o.action = sAction;
            o.value = oCsvCol ? oCsvCol.columnId : mValue;

            oTemplateCol._required = false;
        };

        this.fnSubmit = function () {
            if (vm.bIsLoading) {
                return;
            }

            let i = vm.aTemplateColumns.length,
                bInvalid = false;

            while (i--) {
                if (vm.aTemplateColumns[i].mandatory) {
                    const o = _.find(vm.aMap, {
                        template_column_id: vm.aTemplateColumns[i].field_id,
                    });

                    if (!o) {
                        vm.aTemplateColumns[i]._required = true;
                        bInvalid = true;
                    }
                }
            }

            if (bInvalid) {
                Toaster.toast({
                    type: 'error',
                    message: 'Fill all required fields',
                });
                $(document).scrollTo('#mapping-table', 500, {
                    offset: -1 * $('#page-content').offset().top
                });
                return;
            }

            vm.bIsLoading = true;

            DataTemplatesResource.mapAndConvertFile({}, {
                fileId: $stateParams.fileId,
                csvTemplateId: $stateParams.template.template_id,
                map: vm.aMap,
            }).$promise
                .then(() => {
                    $state.go('index.data.upload');
                    Notific.notify({
                        templateUrl: 'templates/upload-file-notify.html',
                    });
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bIsLoading = false;
                    $(document).scrollTo('#mapping-table', 500, {
                        offset: -1 * $('#page-content').offset().top
                    });
                });
        };

        // pre fill same names
        for (let i = 0, l = this.aTemplateColumns.length; i < l; i++) {
            const o = _.find(this.aCsvColumns, {
                name: this.aTemplateColumns[i].name,
            });

            if (o) {
                // skip for district and campus
                if (o.name === 'District ID' || (o.name === 'Campus ID' && this.sCampusType !== 'file')) {
                    continue;
                }

                this.oSelected.tpl[this.aTemplateColumns[i].field_id] = o;

                vm.aMap.push({
                    template_column_id: this.aTemplateColumns[i].field_id,
                    action: 'link',
                    value: o.columnId,
                });
            }
        }
    }
}

ColumnMappingController.$inject = ['$stateParams', '$state', 'DataTemplatesResource', 'PartnerResource', 'ProjectResource', 'Toaster', 'Notific'];

angular.module('AlumniApp')
    .controller('ColumnMappingController', ColumnMappingController);

class LoginController {
    constructor(Auth, $state, START_ROUTE, Toaster, $rootScope) {
        const vm = this;

        this.bIsLoading = true;
        this.oAuthData = {};

        vm.fnLogin = (oForm) => {
            if (oForm.$invalid) { return; }

            if (vm.bIsLoading) {
                return;
            }

            vm.bIsLoading = true;

            Auth.login({
                username: vm.oAuthData.username,
                password: vm.oAuthData.password
            })
                .then(() => {
                    vm.bIsLoading = false;
                    $state.go(START_ROUTE, { partnerSlug: $rootScope.sPartnerSlug });
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        Auth.getCurrentUser()
            .then((oUser) => {
                vm.bIsLoading = false;
                if (oUser) {
                    Toaster.toast({
                        message: 'Already authorized',
                        type: 'warning'
                    });
                    $state.go(START_ROUTE, { partnerSlug: $rootScope.sPartnerSlug });
                }
            })
            .catch(() => {
                vm.bIsLoading = false;
            });
    }
}

LoginController.$inject = ['Auth', '$state', 'START_ROUTE', 'Toaster', '$rootScope'];

angular.module('AlumniApp')
    .controller('LoginController', LoginController);

class ForgotPasswordController {
    constructor(Auth, $state, START_ROUTE, Toaster) {
        const vm = this;

        this.bIsLoading = true;
        this.oForgotData = {};

        vm.fnForgot = (oForm) => {
            if (oForm.$invalid) { return; }

            if (vm.bIsLoading) {
                return;
            }

            vm.bIsLoading = true;

            Auth.forgotPassword({
                email: vm.oForgotData.username
            })
                .then(() => {
                    vm.bIsLoading = false;
                    Toaster.toast({
                        message: 'Verification email was send',
                        type: 'success'
                    });
                    $state.go('auth.login');
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        Auth.getCurrentUser()
            .then((oUser) => {
                vm.bIsLoading = false;
                if (oUser) {
                    Toaster.toast({
                        message: 'Already authorized',
                        type: 'warning'
                    });
                    $state.go(START_ROUTE);
                }
            })
            .catch(() => {
                vm.bIsLoading = false;
            });
    }
}

ForgotPasswordController.$inject = ['Auth', '$state', 'START_ROUTE', 'Toaster'];

angular.module('AlumniApp')
    .controller('ForgotPasswordController', ForgotPasswordController);

class ResetPasswordController {
    constructor(Auth, $state, START_ROUTE, Toaster) {
        const vm = this;

        this.bIsLoading = true;
        this.oResetData = {
            plainPassword: {
                first: '',
                second: ''
            }
        };
        this.sResetToken = $state.params.resetToken;

        vm.fnReset = (oForm) => {
            if (oForm.$invalid) { return; }

            if (vm.bIsLoading) {
                return;
            }

            if (vm.oResetData.plainPassword.first !== vm.oResetData.plainPassword.second) {
                Toaster.toast({
                    message: 'Password mismatch',
                    type: 'warning'
                });
                return;
            }

            vm.bIsLoading = true;

            Auth.resetPassword(vm.oResetData, vm.sResetToken)
                .then(() => {
                    vm.bIsLoading = false;
                    Toaster.toast({
                        message: 'Reset was successful',
                        type: 'success'
                    });
                    $state.go('auth.login');
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        Auth.getCurrentUser()
            .then((oUser) => {
                vm.bIsLoading = false;
                if (oUser) {
                    Toaster.toast({
                        message: 'Already authorized',
                        type: 'warning'
                    });
                    $state.go(START_ROUTE);
                }
            })
            .catch(() => {
                vm.bIsLoading = false;
            });
    }}

ResetPasswordController.$inject = ['Auth', '$state', 'START_ROUTE', 'Toaster'];

angular.module('AlumniApp')
    .controller('ResetPasswordController', ResetPasswordController);

class ActivateAccountController {
    constructor(Auth, $state, START_ROUTE, Toaster) {
        const vm = this;

        this.bIsLoading = true;
        this.oActivateData = {
            plainPassword: {
                first: '',
                second: ''
            }
        };
        this.sActivateToken = $state.params.activateToken;

        vm.fnActivate = (oForm) => {
            if (oForm.$invalid) { return; }

            if (vm.bIsLoading) {
                return;
            }

            if (vm.oActivateData.plainPassword.first !== vm.oActivateData.plainPassword.second) {
                Toaster.toast({
                    message: 'Password mismatch',
                    type: 'warning'
                });
                return;
            }

            vm.bIsLoading = true;

            Auth.activateAccount(vm.oActivateData, vm.sActivateToken)
                .then(() => {
                    vm.bIsLoading = false;
                    Toaster.toast({
                        message: 'Activate was successful',
                        type: 'success'
                    });
                    $state.go('auth.login');
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        Auth.getCurrentUser()
            .then((oUser) => {
                vm.bIsLoading = false;
                if (oUser) {
                    Toaster.toast({
                        message: 'Already authorized',
                        type: 'warning'
                    });
                    $state.go(START_ROUTE);
                }
            })
            .catch(() => {
                vm.bIsLoading = false;
            });
    }}

ActivateAccountController.$inject = ['Auth', '$state', 'START_ROUTE', 'Toaster'];

angular.module('AlumniApp')
    .controller('ActivateAccountController', ActivateAccountController);

class ReportsListController {
    constructor(CategoryResource, ReportResource, TagResource, Toaster, $timeout, NgTableParams, RolesManager) {
        const vm = this;
        vm.oSearchParams = {};

        const fnGetCategories = () => {
            CategoryResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllCategories = oRes;
                })
                .catch(oRes => Toaster.toastError(oRes));
        };

        // TEMP
        vm.fnGetTags = function (searchString) {
            return TagResource.getAll({ searchString }).$promise
                .then(aTags => aTags)
                .catch(() => {
                    Toaster.toast({
                        message: 'Tag search error!',
                        type: 'warning'
                    });
                });
        };

        const fnGetReports = () => {
            if (vm.oTableParams) {
                vm.oTableParams.reload();
                return;
            }

            vm.oTableParams = new NgTableParams({}, {
                getData: (oParams) => {
                    vm.oSearchParams.order = Object.keys(oParams.sorting())[0];
                    vm.oSearchParams.orderBy = _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]);
                    vm.oSearchParams.limit = oParams.count();
                    vm.oSearchParams.offset = oParams.count() * (oParams.page() - 1);
                    vm.bDataIsLoading = true;
                    return ReportResource.getListForReporting(vm.oSearchParams).$promise
                        .then((oRes) => {
                            vm.bDataIsLoading = false;
                            oParams.total(oRes.total);
                            // Run search again if filter changed
                            if (vm.bLastSearch) {
                                vm.fnSearch();
                            }
                            return oRes.items;
                        })
                        .catch((oRes) => {
                            vm.bDataIsLoading = false;
                            Toaster.toastError(oRes);
                        });
                }
            });
        };

        vm.fnSearch = () => {
            // Not run new search if data is loading
            if (vm.bDataIsLoading) {
                vm.bLastSearch = true;
                return;
            }
            vm.bLastSearch = false;
            $timeout(() => {
                angular.forEach(vm.oFilters, (filter, key) => {
                    if (key === 'tags') {
                        const sSearchString = 'filter[tags][]';
                        vm.oSearchParams[sSearchString] = [];
                        angular.forEach(filter, (oTag) => {
                            vm.oSearchParams[sSearchString].push(oTag.id);
                        });
                    } else {
                        const sSearchString = `filter[${key}]`;
                        vm.oSearchParams[sSearchString] = filter;
                    }
                });
                vm.oTableParams.page(1);
                fnGetReports();
            }, 0);
        };

        vm.fnSearchAuthors = ($select) => {
            if ($select.refreshing) {
                vm.bLastSearchAuthors = true;
                return;
            }
            vm.bLastSearchAuthors = false;
            $select.refreshing = true;
            ReportResource.searchAuthors({ searchString: $select.search }).$promise
                .then((oRes) => {
                    $select.refreshing = false;
                    vm.aAuthors = oRes;
                    if (vm.bLastSearchAuthors) {
                        vm.fnSearchAuthors($select);
                    }
                })
                .catch((oRes) => {
                    $select.refreshing = false;
                    Toaster.toastError(oRes);
                });
        };

        vm.bAccessToPage = RolesManager.checkMany(['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORTING'], 'OR');

        if (vm.bAccessToPage) {
            fnGetReports();
            fnGetCategories();
        }
    }
}

ReportsListController.$inject = ['CategoryResource', 'ReportResource', 'TagResource', 'Toaster', '$timeout', 'NgTableParams', 'RolesManager'];

angular.module('AlumniApp')
    .controller('ReportsListController', ReportsListController);

class ReportDetailsController {
    constructor($rootScope, ReportResource, $stateParams, Toaster, $scope) {
        const vm = this;
	$rootScope.currentReport = {};
        vm.reportLoaded = false;

        $rootScope.bPageContentPaddingTop = false;

        ReportResource.showById({ id: $stateParams.id }).$promise
            .then((oRes) => {
            vm.oCurrentReport = oRes;
	    $rootScope.currentReport = oRes;
		    var split_id = oRes.powerBIUrl.split('&groupId=')[0];
		    const sCurrentReportId = split_id.split('reportId=')[1];
		    vm.embedConfiguration = {
			    type: 'report',
			    tokenType: 1,
			    accessToken: vm.oCurrentReport.key,
			    id: sCurrentReportId,
			    name: 'Retail Analysis',
			    embedUrl: oRes.powerBIUrl,
			    allowFullScreen: true,
			    settings: {
				    filterPaneEnabled: !!oRes.report.enabledFilters,
				    navContentPaneEnabled: !!oRes.report.enabledTabs
			    }
		    };
	    })
            .catch(oRes => Toaster.toastError(oRes));

        vm.printReport = () => {
            powerbi.embeds[0]
                .print()
                .catch((error) => {
                    Toaster.toastError(error);
                });
        };

        vm.fullScreenReport = () => {
            powerbi.embeds[0].fullscreen();
        };

        vm.onEmbedded = () => {
            powerbi.embeds[0].on('loaded', () => {
                vm.reportLoaded = true;
                $scope.$apply();
            });
        };
    }
}

ReportDetailsController.$inject = ['$rootScope', 'ReportResource', '$stateParams', 'Toaster', '$scope'];

angular.module('AlumniApp')
    .controller('ReportDetailsController', ReportDetailsController);

class CategoriesManagementAddController {
    constructor($scope, $state, CategoryResource, FormManager, Toaster, ErrorManager) {
        const vm = this;

        vm.oCategoryData = {
            name: '',
            description: '',
            sort: ''
        };

        vm.bIsLoading = false;

        FormManager.watch($scope, 'oNewCategoryForm');

        vm.fnSubmitCategory = (oForm) => {
            vm.bIsLoading = true;
            CategoryResource.addCategory(vm.oCategoryData).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Add new category',
                        type: 'success'
                    });
                    $state.go('index.report-management.categories-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };
    }
}

CategoriesManagementAddController.$inject = ['$scope', '$state', 'CategoryResource', 'FormManager', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('CategoriesManagementAddController', CategoriesManagementAddController);

class CategoriesManagementEditController {
    constructor($scope, $state, $stateParams, CategoryResource, FormManager, Toaster, ErrorManager) {
        const vm = this;

        vm.bIsLoading = true;

        CategoryResource.getById({ id: $stateParams.id }).$promise
            .then((oRes) => {
                vm.currentId = oRes.id;
                vm.oCategoryData = {
                    name: oRes.name,
                    description: oRes.description,
                    sort: oRes.sort
                };
                vm.bIsLoading = false;
            })
            .catch((oRes) => {
                vm.bIsLoading = false;
                Toaster.toastError(oRes);
                $state.go('index.report-management.categories-list');
            });

        FormManager.watch($scope, 'oCategoryForm');

        vm.fnSubmitCategory = (oForm) => {
            vm.bIsLoading = true;
            CategoryResource.updateCategory({ id: vm.currentId }, vm.oCategoryData).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Update was successful',
                        type: 'success'
                    });
                    $state.go('index.report-management.categories-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        vm.fnDeleteCategory = (event, id) => {
            const bConfirm = confirm('This category will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            CategoryResource.deleteCategory({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    $state.go('index.report-management.categories-list');
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

CategoriesManagementEditController.$inject = ['$scope', '$state', '$stateParams', 'CategoryResource', 'FormManager', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('CategoriesManagementEditController', CategoriesManagementEditController);

class CategoriesManagementListController {
    constructor(NgTableParams, CategoryResource, Toaster) {
        const vm = this;

        vm.oTableParams = new NgTableParams({}, {
            getData: oParams => CategoryResource.getForTable({
                order: Object.keys(oParams.sorting())[0],
                orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                limit: oParams.count(),
                offset: oParams.count() * (oParams.page() - 1)
            }).$promise
                    .then((oRes) => {
                        oParams.total(oRes.total);
                        return oRes.items;
                    })
                    .catch((oRes) => {
                        Toaster.toastError(oRes);
                    })
        });

        vm.fnDeleteCategory = (event, id) => {
            const bConfirm = confirm('This category will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return CategoryResource.deleteCategory({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

CategoriesManagementListController.$inject = ['NgTableParams', 'CategoryResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('CategoriesManagementListController', CategoriesManagementListController);

class ReportsManagementAddController {
    constructor($scope, $state, ReportResource, TagResource, CategoryResource, FormManager, Toaster, ErrorManager,
                FileUploader, PowerBIWorkspaceResource, PartnerResource, ProjectResource, ApplicationDatabaseResource, PowerBiUserResource) {
        const vm = this;
        const oUploader = vm.oUploader = new FileUploader();

        vm.tags = [];
        vm.oReportData = {
            enabledTabs: 1,
            enabledFilters: 1,
            isPublic: 0
        };

        FormManager.watch($scope, 'oNewReportForm');

        oUploader.onWhenAddingFileFailed = function () {
            vm.oReportData.file = null;
        };

        oUploader.onAfterAddingFile = function (fileItem) {
            vm.oReportData.file = fileItem._file;
        };

        /**
         * Get Reporting Databases
         */
        const fnGetReportingDatabases = () => {
            vm.bReportingDatabasesIsLoading = true;

            PowerBIWorkspaceResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllReportingDatabases = oRes;
                    vm.bReportingDatabasesIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bReportingDatabasesIsLoading = false;
                });
        };

        /**
         * Get Categories
         */
        const fnGetCategories = () => {
            vm.bCategoriesIsLoading = true;

            CategoryResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllCategories = oRes;
                    vm.bCategoriesIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bCategoriesIsLoading = false;
                });
        };

        /**
         * Get partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.aPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bPartnersIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        /**
          * Get application databases
         */
        const fnGetApplication = () => {
            vm.bApplicationIsLoading = true;

            ApplicationDatabaseResource.getAll().$promise
                .then((oRes) => {
                  vm.aApplication = oRes;
                  vm.bApplicationIsLoading = false;
                })
                .catch((oRes) => {
                  vm.bApplicationIsLoading = false;
                  Toaster.toastError(oRes);
                });
        };

        /**
         * Get projects by partner
         */
        vm.fnGetProjects = () => {
            if (!vm.partner) return;

            if (vm.bProjectsIsLoading) {
                vm.bLastProjectsRequest = true;
                return;
            }

            vm.bLastProjectsRequest = false;
            vm.oReportData.project = null;
            vm.bProjectsIsLoading = true;

            ProjectResource.getAllByPartner({ partnerId: vm.partner }).$promise
                .then((oRes) => {
                    vm.aProjects = oRes;
                    vm.bProjectsIsLoading = false;
                    if (vm.bLastProjectsRequest) {
                        vm.fnGetProjects();
                    }
                })
                .catch((oRes) => {
                    vm.bProjectsIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };


	            /**
		     *           * Get PowerBI users list
		     *                    */
	            const fnGetPowerBiUserslist = () => {
			                vm.bPowerbiuserIsLoading = true;

			                PowerBiUserResource.getAll().$promise
			                    .then((oRes) => {
						                      vm.aPowerbiuser = oRes;
						                      vm.bPowerbiuserIsLoading = false;
						                    })
			                    .catch((oRes) => {
						                      vm.bPowerbiuserIsLoading = false;
						                      Toaster.toastError(oRes);
						                    });
			            };


        /**
         * Load Tags
         * @param searchString
         */
        vm.loadTags = function (searchString) {
            return TagResource.getAll({ searchString }).$promise
                .then(aTags => aTags)
                .catch(() => {
                    Toaster.toast({
                        message: 'Tag search error!',
                        type: 'warning'
                    });
                });
        };

        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmitReport = (oForm) => {
            vm.bIsLoading = true;
            const oCurrentReport = _.clone(vm.oReportData);
            if (vm.tags.length) {
                oCurrentReport.tags = vm.tags.map(oItem => ({
                    name: oItem.name
                }));
            } else {
                delete oCurrentReport.tags;
            }

            ReportResource.addReport(oCurrentReport).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    $state.go('index.report-management.reports-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                });
        };

        fnGetReportingDatabases();
        fnGetCategories();
        fnGetPartners();
	fnGetApplication();
	fnGetPowerBiUserslist();
    }
}

ReportsManagementAddController.$inject = ['$scope', '$state', 'ReportResource', 'TagResource', 'CategoryResource',
    'FormManager', 'Toaster', 'ErrorManager', 'FileUploader', 'PowerBIWorkspaceResource', 'PartnerResource', 'ProjectResource','ApplicationDatabaseResource', 'PowerBiUserResource'];

angular.module('AlumniApp')
    .controller('ReportsManagementAddController', ReportsManagementAddController);

class ReportsManagementEditController {
    constructor($scope, $state, $stateParams, ReportResource, TagResource, CategoryResource, FormManager, Toaster, ErrorManager, RolesManager, FileUploader, PowerBIWorkspaceResource, ApplicationDatabaseResource, PowerBiUserResource, $rootScope, ProjectResource, PartnerResource, $timeout, $q) {
        const vm = this;
        vm.oReportData = {};

        FormManager.watch($scope, 'oReportForm');

        const oUploader = vm.oUploader = new FileUploader();
        oUploader.onWhenAddingFileFailed = function () {
            vm.oReportData.file = null;
        };
        oUploader.onAfterAddingFile = function (fileItem) {
            vm.oReportData.file = fileItem._file;
            $scope.oReportForm.$setDirty();
        };

        vm.loadTags = function (searchString) {
            return TagResource.getAll({ searchString }).$promise
                .then(aTags => aTags)
                .catch(() => {
                    Toaster.toast({
                        message: 'Tag search error!',
                        type: 'warning'
                    });
                });
        };

        const fnCheckUserRoles = () => {
            if (!$rootScope.oCurrentUser) return;
            vm.bUserFullRightsForReports = RolesManager.checkMany(['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL'], 'OR');
        };

        /**
         * Get Reporting Databases
         */
        const fnGetPowerBIWorkspaces = () => {
            if (!vm.bUserFullRightsForReports) return;

            vm.bPowerBIWorkspaceIsLoadinbg = true;
            PowerBIWorkspaceResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllPowerBIWorkspaces = oRes;
                    vm.bPowerBIWorkspaceIsLoadinbg = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bPowerBIWorkspaceIsLoadinbg = false;
                });
        };

        /**
         * Get Categories
         */
        const fnGetCategories = () => {
            vm.bCategoriesIsLoading = true;

            CategoryResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllCategories = oRes;
                    vm.bCategoriesIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bCategoriesIsLoading = false;
                });
        };

        /**
         * Get application databases
         */
        const fnGetApplication = () => {
            vm.bApplicationIsLoading = true;

            ApplicationDatabaseResource.getAll().$promise
                .then((oRes) => {
                    vm.aApplication = oRes;
                    vm.bApplicationIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bApplicationIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        /**
         * Get projects by partner
         */
        vm.fnGetProjects = () => {
            if (!vm.partner) return;

            if (vm.bProjectsIsLoading) {
                vm.bLastProjectsRequest = true;
                return;
            }

            if (vm.iOriginalPartner !== vm.partner) {
                vm.oReportData.project = null;
            }

            vm.bLastProjectsRequest = false;
            vm.bProjectsIsLoading = true;

            ProjectResource.getAllByPartner({ partnerId: vm.partner }).$promise
                .then((oRes) => {
                    vm.aProjects = oRes;
                    vm.bProjectsIsLoading = false;
                    if (vm.bLastProjectsRequest) {
                        vm.fnGetProjects();
                    }
                })
                .catch((oRes) => {
                    vm.bProjectsIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        /**
         * Get Report
         */
        const fnGetReport = () => {
            vm.bIsLoading = true;

            ReportResource.getByIdForManagement({ id: $stateParams.id }).$promise
                .then((oRes) => {
                    vm.bIsLoading = false;
                    vm.currentId = oRes.id;
                    vm.tags = oRes.tags;
                    vm.currentPowerBIWorkspace = oRes.powerBIWorkspace ? oRes.powerBIWorkspace.id : null;
                    vm.currentPowerbiuser = oRes.powerbiuser ? oRes.powerbiuser.id : null;
		    vm.iOriginalProjectId = oRes.project.id;
                    vm.currentAppID = oRes.app_db_id ? oRes.app_db_id.id : '';
                    vm.oReportData = {
                        name: oRes.name,
                        description: oRes.description,
                        powerBIWorkspace: vm.currentPowerBIWorkspace,
			appDbId: vm.currentAppID,
                        tags: vm.tags,
                        category: oRes.category.id,
                        project: oRes.project.id,
			powerbiuser: vm.currentPowerbiuser,
                        rls: oRes.rls,
                        slug: oRes.slug
                    };
                    vm.partner = oRes.project.partner.id;
                    vm.iOriginalPartner = oRes.project.partner.id;

                    // Need delay to enable bootstrap-switch
                    $timeout(() => {
                        vm.oReportData.enabledFilters = oRes.enabledFilters ? 1 : 0;
                        vm.oReportData.enabledTabs = oRes.enabledTabs ? 1 : 0;
                        vm.oReportData.isPublic = oRes.isPublic ? 1 : 0;
                        FormManager.setPristineWatched();
                    }, 0);

                    vm.fnGetProjects();
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                    $state.go('index.report-management.reports-list');
                });
        };

        /**
         * Get partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.aPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bPartnersIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        /**
	 *          * Get partners
	 *                   */
	            const fnGetPowerbiuser = () => {
			                vm.bPowerbiuserIsLoading = true;

			                PowerBiUserResource.getAll().$promise
			                    .then((oRes) => {
						                        vm.aPowerbiuser = oRes;
						                        vm.bPowerbiuserIsLoading = false;
						                    })
			                    .catch((oRes) => {
						                        vm.bPowerbiuserIsLoading = false;
						                        Toaster.toastError(oRes);
						                    });
			            };


        vm.fnSubmitReport = (oForm) => {
            const oCurrentReport = _.clone(vm.oReportData);

            if (!vm.bUserFullRightsForReports) {
                delete oCurrentReport.file;
                delete oCurrentReport.powerBIWorkspace;
            }
            if (vm.bUserFullRightsForReports && vm.currentPowerBIWorkspace !== oCurrentReport.powerBIWorkspace && !oCurrentReport.file) {
                Toaster.toast({
                    message: 'You have changed the ReportingDatabase so need to choose a new file.',
                    type: 'warning'
                });
                return;
            }
            vm.bIsLoading = true;

            ReportResource.updateReport({ id: vm.currentId }, oCurrentReport).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Update was successfull. '+ oRes.message,
                        type: 'success'
                    });
                    $state.go('index.report-management.reports-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        vm.fnDeleteReport = (event, id) => {
            const bConfirm = confirm('This report will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return ReportResource.deleteReport({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    $state.go('index.report-management.reports-list');
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };

        fnCheckUserRoles();
        fnGetCategories();
        fnGetReport();
        fnGetPartners();
        fnGetPowerBIWorkspaces();
        fnGetApplication();
	fnGetPowerbiuser();
    }
}

ReportsManagementEditController.$inject = ['$scope', '$state', '$stateParams', 'ReportResource', 'TagResource', 'CategoryResource', 'FormManager', 'Toaster', 'ErrorManager', 'RolesManager', 'FileUploader', 'PowerBIWorkspaceResource', 'ApplicationDatabaseResource', 'PowerBiUserResource', '$rootScope', 'ProjectResource', 'PartnerResource', '$timeout', '$q'];

angular.module('AlumniApp')
    .controller('ReportsManagementEditController', ReportsManagementEditController);

class ReportsManagementListController {
    constructor(NgTableParams, ReportResource, Toaster, $rootScope, RolesManager) {
        const vm = this;

        const fnCheckUserRoles = () => {
            vm.bUserFullRightsForReports = RolesManager.checkMany(['ROLE_SUPER_ADMIN', 'ROLE_USE_REPORT_MANAGEMENT_FULL'], 'OR');
        };

        vm.oTableParams = new NgTableParams({}, {
            getData: oParams => ReportResource.getListForManagement({
                order: Object.keys(oParams.sorting())[0],
                orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                limit: oParams.count(),
                offset: oParams.count() * (oParams.page() - 1)
            }).$promise
                .then((oRes) => {
                    oParams.total(oRes.total);
                    return oRes.items;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.fnDeleteReport = (event, id) => {
            const bConfirm = confirm('This report will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return ReportResource.deleteReport({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };

        fnCheckUserRoles();
    }
}

ReportsManagementListController.$inject = ['NgTableParams', 'ReportResource', 'Toaster', '$rootScope', 'RolesManager'];

angular.module('AlumniApp')
    .controller('ReportsManagementListController', ReportsManagementListController);

class UsersManagementAddController {
    constructor($scope, $state, UserResource, PartnerResource, ProjectResource, GroupNRoleResource, FormManager, Toaster,
                ErrorManager, ApplicationAccessResource) {
        const vm = this;

        // Avoid jump
        $('.nav-tabs li a').click((e) => {
            e.preventDefault();
        });

        FormManager.watch($scope, 'oNewUserForm');

        /**
         * Get Partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAllowed().$promise
                .then((oRes) => {
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bPartnersIsLoading = false;
                });
        };

        /**
         * Get Allowed Projects (application access)
         */
        const fnGetProjectAccesses = () => {
            vm.bProjectAccessIsLoading = true;

            ApplicationAccessResource.getAllowedProjects().$promise
                .then((oRes) => {
                    vm.aAllProjectAccess = oRes;
                    vm.bProjectAccessIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bProjectAccessIsLoading = false;
                });
        };

        /**
         * Get Groups of Roles
         */
        const fnGetGroups = () => {
            vm.bGroupsLoading = true;

            GroupNRoleResource.getAllowed().$promise
                .then((oRes) => {
                    vm.aAllGroups = oRes;
                    vm.bGroupsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bGrpupsLoading = false;
                });
        };

        /**
         * Get Projects by Partner
         */
        vm.fnGetProjects = () => {
            if (!vm.oUserData.partner) return;

            vm.bProjectsIsLoading = true;
            ProjectResource.getAllowedByPartner({ partnerId: vm.oUserData.partner }).$promise
                .then((oRes) => {
                    vm.oUserData.project = null;
                    vm.aAllProjects = oRes;
                    vm.bProjectsIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bProjectsIsLoading = false;
                });
        };

        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmitUser = (oForm) => {
            const oCurrentUser = _.clone(vm.oUserData);
            if (vm.groupLevel !== 2) {
                delete oCurrentUser.project;
            }
            vm.bFormLoading = true;
            UserResource.addUser(oCurrentUser).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Add new user',
                        type: 'success'
                    });
                    $state.go('index.users-management.users-list');
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bFormLoading = false;
                });
        };

        /**
         * Get Group level
         */
        vm.getLevel = () => {
            if (!vm.oUserData.groups) {
                vm.groupLevel = null;
                return;
            }

            for (let i = 0; i < vm.oUserData.groups.length; i++) {
                if (i === 0) {
                    _.forEach(vm.aAllGroups, (val) => {
                        if (val.id === vm.oUserData.groups[i]) vm.groupLevel = val.level;
                    });
                } else {
                    if (vm.groupLevel === 2) break;
                    _.forEach(vm.aAllGroups, (val) => {
                        if (val.id === vm.oUserData.groups[i] && val.level) vm.groupLevel = val.level;
                    });
                }
            }
        };

        fnGetPartners();
        fnGetProjectAccesses();
        fnGetGroups();
    }
}

UsersManagementAddController.$inject = ['$scope', '$state', 'UserResource', 'PartnerResource', 'ProjectResource', 'GroupNRoleResource',
    'FormManager', 'Toaster', 'ErrorManager', 'ApplicationAccessResource'];

angular.module('AlumniApp')
    .controller('UsersManagementAddController', UsersManagementAddController);

class UsersManagementEditController {
    constructor($scope, $state, $stateParams, $timeout, UserResource, PartnerResource, ProjectResource, GroupNRoleResource,
                FormManager, Toaster, ErrorManager, ApplicationAccessResource) {
        const vm = this;

        // Avoid jump
        $('.nav-tabs li a').click((e) => {
            e.preventDefault();
        });

        FormManager.watch($scope, 'oUserForm');

        /**
         * Get Partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAllowed().$promise
                .then((oRes) => {
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bPartnersIsLoading = false;
                });
        };

        /**
         * Get Allowed Projects (application access)
         */
        const fnGetProjectAccesses = () => {
            vm.bProjectAccessIsLoading = true;

            ApplicationAccessResource.getAllowedProjects().$promise
                .then((oRes) => {
                    vm.aAllProjectAccess = oRes;
                    vm.bProjectAccessIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bProjectAccessIsLoading = false;
                });
        };

        /**
         * Get Groups of Roles
         */
        const fnGetGroups = () => {
            vm.bGroupsLoading = true;

            GroupNRoleResource.getAllowed().$promise
                .then((oRes) => {
                    vm.aAllGroups = oRes;
                    vm.bGroupsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bGrpupsLoading = false;
                });
        };

        const fnGetUser = () => {
            vm.bIsLoading = true;

            UserResource.getById({ id: $stateParams.id }).$promise
                .then((oRes) => {
                    vm.status = oRes.status;
                    vm.currentId = oRes.id;
                    vm.brieflyDescribe = oRes.brieflyDescribe;
                    vm.oUserData = {
                        partner: oRes.partner ? oRes.partner.id : null,
                        project: oRes.project ? oRes.project.id : null,
                        department: oRes.department,
                        titlePosition: oRes.titlePosition,
                        firstName: oRes.firstName,
                        lastName: oRes.lastName,
                        email: oRes.email,
                        phone: oRes.phone,
                        approve: oRes.status,
                        groups: _.map(oRes.groups, group => group.id),
                        projectAccess: _.map(oRes.projectAccess, projectAccess => projectAccess.id),
                        plainPassword: {
                            first: null,
                            second: null
                        },
                    };
                    vm.oOriginalUserData = _.clone(vm.oUserData);
                    vm.getLevel();
                    vm.fnGetProjects();
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                    $state.go('index.users-management.users-list');
                });
        };

        /**
         * Get Projects by Partner
         */
        vm.fnGetProjects = () => {
            if (!vm.oUserData.partner) return;

            if (vm.oOriginalUserData.partner !== vm.oUserData.partner) vm.oUserData.project = null;

            vm.bProjectsIsLoading = true;
            ProjectResource.getAllowedByPartner({ partnerId: vm.oUserData.partner }).$promise
                .then((oRes) => {
                    vm.aAllProjects = oRes;
                    vm.bProjectsIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bProjectsIsLoading = false;
                });
        };

        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmitUser = (oForm) => {
            const oCurrentUser = _.clone(vm.oUserData);
            if (!oCurrentUser.plainPassword.first && !oCurrentUser.plainPassword.second) {
                delete oCurrentUser.plainPassword;
            }
            if (vm.groupLevel !== 2) delete oCurrentUser.project;

            vm.bIsLoading = true;

            UserResource.updateUser({ id: vm.currentId }, oCurrentUser).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Update was successful',
                        type: 'success'
                    });
                    $state.go('index.users-management.users-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                });
        };

        /**
         * Delete User
         * @param event
         * @param id
         */
        vm.fnDeleteUser = (event, id) => {
            const bConfirm = confirm('This user will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return UserResource.deleteUser({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    $state.go('index.users-management.users-list');
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };

        /**
         * Get Group level
         */
        vm.getLevel = () => {
            if (!vm.oUserData.groups) {
                vm.groupLevel = null;
                return;
            }

            for (let i = 0; i < vm.oUserData.groups.length; i++) {
                if (i === 0) {
                    _.forEach(vm.aAllGroups, (val) => {
                        if (val.id === vm.oUserData.groups[i]) vm.groupLevel = val.level;
                    });
                } else {
                    if (vm.groupLevel === 2) break;
                    _.forEach(vm.aAllGroups, (val) => {
                        if (val.id === vm.oUserData.groups[i] && val.level) vm.groupLevel = val.level;
                    });
                }
            }
        };

        fnGetPartners();
        fnGetProjectAccesses();
        fnGetGroups();
        fnGetUser();
    }
}

UsersManagementEditController.$inject = ['$scope', '$state', '$stateParams', '$timeout', 'UserResource', 'PartnerResource',
    'ProjectResource', 'GroupNRoleResource', 'FormManager', 'Toaster', 'ErrorManager',
    'ApplicationAccessResource'];

angular.module('AlumniApp')
    .controller('UsersManagementEditController', UsersManagementEditController);

class UsersManagementListController {
    constructor($filter, NgTableParams, UserResource, Toaster) {
        const vm = this;

        vm.oTableParams = new NgTableParams({}, {
            getData: oParams => UserResource.getForActiveTable({
                order: Object.keys(oParams.sorting())[0],
                orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                limit: oParams.count(),
                offset: oParams.count() * (oParams.page() - 1)
            }).$promise
                .then((oRes) => {
                    oParams.total(oRes.total);
                    return oRes.items;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.fnGetFormatDate = nDate => $filter('date')(nDate * 1000, 'MM/dd/yy h:mm a');

        vm.fnDeleteUser = (event, id) => {
            const bConfirm = confirm('This user will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return UserResource.deleteUser({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

UsersManagementListController.$inject = ['$filter', 'NgTableParams', 'UserResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('UsersManagementListController', UsersManagementListController);

class UsersManagementListPendingController {
    constructor($filter, NgTableParams, UserResource, Toaster) {
        const vm = this;

        vm.oTableParams = new NgTableParams({}, {
            getData: oParams => UserResource.getForPendingTable({
                order: Object.keys(oParams.sorting())[0],
                orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                limit: oParams.count(),
                offset: oParams.count() * (oParams.page() - 1)
            }).$promise
                .then((oRes) => {
                    oParams.total(oRes.total);
                    return oRes.items;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.fnGetFormatDate = nDate => $filter('date')(nDate * 1000, 'MM/dd/yy h:mm a');

        vm.fnApproveUser = (event, id) => {
            const bConfirm = confirm('This user will be approved. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return UserResource.approveUser({ id }, null).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Approve was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };

        vm.fnDeleteUser = (event, id) => {
            const bConfirm = confirm('This user will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return UserResource.deleteUser({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

UsersManagementListPendingController.$inject = ['$filter', 'NgTableParams', 'UserResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('UsersManagementListPendingController', UsersManagementListPendingController);

class UsersManagementListUnconfirmedController {
    constructor($filter, NgTableParams, UserResource, Toaster) {
        const vm = this;

        vm.oTableParams = new NgTableParams({}, {
            getData: oParams => UserResource.getForUnconfirmedTable({
                order: Object.keys(oParams.sorting())[0],
                orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                limit: oParams.count(),
                offset: oParams.count() * (oParams.page() - 1)
            }).$promise
                .then((oRes) => {
                    oParams.total(oRes.total);
                    return oRes.items;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.fnGetFormatDate = nDate => $filter('date')(nDate * 1000, 'MM/dd/yy h:mm a');

        vm.fnConfirmEmail = (event, id) => {
            const bConfirm = confirm('Are you going to confirm the email address of the user. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return UserResource.confirmEmailFromAdmin({ id }, null).$promise
                .then((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };

        vm.fnDeleteUser = (event, id) => {
            const bConfirm = confirm('This user will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return UserResource.deleteUser({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

UsersManagementListUnconfirmedController.$inject = ['$filter', 'NgTableParams', 'UserResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('UsersManagementListUnconfirmedController', UsersManagementListUnconfirmedController);

class RolesManagementAddController {
    constructor($scope, $state, GroupNRoleResource, FormManager, Toaster, ErrorManager) {
        const vm = this;

        vm.bIsLoading = true;

        const oGroupSelect = $('#singleParentGroupSelect').select2({
            placeholder: 'Select a Parent Role'
        });

        GroupNRoleResource.getRoles().$promise
            .then((oRes) => {
                vm.oRoleData = {
                    name: '',
                    roles: [],
                };
                vm.aAllRoles = oRes;
                vm.currentRoles = [];
                vm.bIsLoading = false;
            })
            .catch((oRes) => {
                Toaster.toastError(oRes);
            });

        vm.fnGetGroupsAsParent = (groupLvl) => {
            vm.bParentGroupLoading = true;
            vm.oRoleData.parent = '';
            GroupNRoleResource.getGroupsAsParentByLvl({groupLvl: groupLvl}).$promise
                .then((oRes) => {
                    vm.aAllParentGroups = oRes;
                    vm.bParentGroupLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bParentGroupLoading = false;
                });
        };

        FormManager.watch($scope, 'oNewRoleForm');

        vm.fnSubmitRole = (oForm) => {
            vm.bIsLoading = true;
            vm.oRoleData.roles = [];
            for (let i = 0; i < vm.aAllRoles.length; i++) {
                if (vm.currentRoles[i]) {
                    vm.oRoleData.roles.push(vm.aAllRoles[i].id);
                }
            }
            GroupNRoleResource.addGroup(vm.oRoleData).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Add new role',
                        type: 'success'
                    });
                    $state.go('index.users-management.roles-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };
    }
}

RolesManagementAddController.$inject = ['$scope', '$state', 'GroupNRoleResource', 'FormManager', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('RolesManagementAddController', RolesManagementAddController);

class RolesManagementEditController {
    constructor($scope, $state, $stateParams, GroupNRoleResource, FormManager, Toaster, ErrorManager, $timeout) {
        const vm = this;

        vm.bIsLoading = true;
        vm.bParentGroupLoading = true;

        const oGroupSelect = $('#singleParentGroupSelect').select2({
            placeholder: 'Select a Parent Role'
        });

        vm.fnGetGroupsAsParent = (groupLvl) => {
            GroupNRoleResource.getGroupsForParent({groupId: $stateParams.id, groupLvl: groupLvl}).$promise
                .then((oRes) => {
                    vm.aAllParentGroups = oRes;
                    vm.bParentGroupLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bParentGroupLoading = false;
                });
        };
        
        vm.fnGetGroupsAsParentByChange = (groupLvl) => {
            vm.bParentGroupLoading = true;
            vm.oRoleData.parent = '';
            vm.fnGetGroupsAsParent(groupLvl);
        };

        GroupNRoleResource.getRoles().$promise
            .then((oRoles) => {
                vm.aAllRoles = oRoles;
                vm.currentRoles = [];
                return GroupNRoleResource.getGroupsById({ id: $stateParams.id }).$promise;
            })
            .then((oGroupsById) => {
                vm.currentId = oGroupsById.id;
                vm.oRoleData = {
                    name: oGroupsById.name,
                    level: oGroupsById.level,
                    roles: [],
                    description: oGroupsById.description,
                    parent: oGroupsById.parent
                };
                vm.oRoleData.roles = oGroupsById.roles.map(oItem => (oItem.id));
                for (let i = 0; i < vm.aAllRoles.length; i++) {
                    if (_.find(vm.oRoleData.roles, oRole => (oRole === vm.aAllRoles[i].id))) {
                        vm.currentRoles[i] = true;
                    }
                }

                vm.fnGetGroupsAsParent(oGroupsById.level);

                // use watch for trigger set current group after load list of group
                const fnGroupsWatch = $scope.$watch('vm.aAllParentGroups', () => {
                    if (!oGroupsById.parent) return;
                    // use timeout for prevent digest error
                    $timeout(() => {
                        const iGroupId = oGroupsById.parent ? oGroupsById.parent.id : null;
                        oGroupSelect.val(iGroupId).trigger('change');
                        $scope.oRoleForm.$setPristine();
                    }, 0);
                    if (vm.aAllParentGroups) {
                        fnGroupsWatch();
                    }
                });

                $scope.oRoleForm.$setPristine();
                vm.bIsLoading = false;
            })
            .catch((oRes) => {
                vm.bIsLoading = false;
                Toaster.toastError(oRes);
                $state.go('index.users-management.roles-list');
            });

        FormManager.watch($scope, 'oRoleForm');

        vm.fnSubmitRole = (oForm) => {
            vm.bIsLoading = true;
            vm.oRoleData.roles = [];
            for (let i = 0; i < vm.aAllRoles.length; i++) {
                if (vm.currentRoles[i]) {
                    vm.oRoleData.roles.push(vm.aAllRoles[i].id);
                }
            }
            GroupNRoleResource.updateGroup({ id: vm.currentId }, vm.oRoleData).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Update was successful',
                        type: 'success'
                    });
                    $state.go('index.users-management.roles-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        vm.fnDeleteRole = (event) => {
            const bConfirm = confirm('This role will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return GroupNRoleResource.deleteGroup({ id: vm.currentId }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    $state.go('index.users-management.roles-list');
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

RolesManagementEditController.$inject = ['$scope', '$state', '$stateParams', 'GroupNRoleResource', 'FormManager', 'Toaster', 'ErrorManager', '$timeout'];

angular.module('AlumniApp')
    .controller('RolesManagementEditController', RolesManagementEditController);

class RolesManagementEditAllController {
    constructor(NgTableParams, GroupNRoleResource, Toaster, ErrorManager) {
        const vm = this;

        vm.check = {};

        vm.oGridTableParams = new NgTableParams({
            page: 1,    // show first page
            count: 1000 // count per page
        }, {
            counts: [], // hide page counts control
            total: 1,   // value less than count hide pagination
            getData: oParams => GroupNRoleResource.getGroups().$promise
                .then(oResGroups => GroupNRoleResource.getRoles().$promise
                    .then((oResRoles) => {
                        vm.aAllRoles = oResRoles;
                        vm.cols = [{ title: '', field: 'title' }];
                        vm.cols.push(oResGroups.map(oItem => ({
                            title: oItem.name,
                            field: oItem
                        })));
                        vm.cols = _.flattenDeep(vm.cols);
                        oParams.total(oResRoles.length);
                        return oResRoles;
                    }))
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.fnCheckAccess = (row, col) => {
            const iIndex = _.find(col.roles, oRolesInGroup => oRolesInGroup.id === row.id);
            return !!iIndex;
        };

        vm.switchPermission = (oRole, oPermission) => {
            const sAction = (vm.check[oRole.name] && vm.check[oRole.name][oPermission.role]) ? 'add' : 'delete';
            GroupNRoleResource.updatePermission({ id: oRole.id }, { action: sAction, roleId: oPermission.id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Update was successful',
                        type: 'success'
                    });
                })
                .catch((oRes) => {
                    ErrorManager.toastError(oRes);
                });
        };

        vm.fnCheckAccess = (row, col) => {
            const iIndex = _.find(col.roles, oRolesInGroup => oRolesInGroup.id === row.id);
            return !!iIndex;
        };
    }
}

RolesManagementEditAllController.$inject = ['NgTableParams', 'GroupNRoleResource', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('RolesManagementEditAllController', RolesManagementEditAllController);

class RolesManagementListController {
    constructor($filter, NgTableParams, GroupNRoleResource, Toaster) {
        const vm = this;

        vm.oRolesTableParams = new NgTableParams({
            page: 1,    // show first page
            count: 1000 // count per page
        }, {
            counts: [], // hide page counts control
            total: 1,   // value less than count hide pagination
            getData: oParams => GroupNRoleResource.getGroups().$promise
                .then((oRes) => {
                    vm.aAllGroups = oRes;
                    oParams.total(oRes.length);
                    return oRes;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.oGridTableParams = new NgTableParams({
            page: 1,    // show first page
            count: 1000 // count per page
        }, {
            counts: [], // hide page counts control
            total: 1,   // value less than count hide pagination
            getData: oParams => GroupNRoleResource.getGroups().$promise
                .then(oResGroups => GroupNRoleResource.getRoles().$promise
                        .then((oResRoles) => {
                            vm.aAllRoles = oResRoles;
                            vm.cols = [{ title: '', field: 'title' }];
                            vm.cols.push(oResGroups.map(oItem => ({
                                title: oItem.name,
                                field: oItem
                            })));
                            vm.cols = _.flattenDeep(vm.cols);
                            oParams.total(oResRoles.length);
                            return oResRoles;
                        })
                        .catch((oRes) => {
                            Toaster.toastError(oRes);
                        }))
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                })
        });

        vm.fnCheckAccess = (row, col) => {
            const iIndex = _.find(col.roles, oRolesInGroup => oRolesInGroup.id === row.id);
            return !!iIndex;
        };

        vm.fnGetFormatDate = sDate => $filter('date')(sDate, 'MM/dd/yy h:mm a');

        vm.fnDeleteRole = (event, id) => {
            const bConfirm = confirm('This role will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return GroupNRoleResource.deleteGroup({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oRolesTableParams.reload();
                    vm.oGridTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

RolesManagementListController.$inject = ['$filter', 'NgTableParams', 'GroupNRoleResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('RolesManagementListController', RolesManagementListController);

class ProfileController {
    constructor($uibModal) {
        const vm = this;
        vm.timestamp = new Date().getTime();

        vm.aTabs = [
            {
                title: 'Personal Info',
                state: 'index.profile.edit'
            },
            {
                title: 'Change Password',
                state: 'index.profile.change-password'
            }
        ];

        vm.fnUploadAvatar = () => {
            $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: 'views/avatar-crop-popup.html',
                backdropClass: 'modal-back',
                windowClass: 'modal-window',
                controller: 'UserProfileAvatarCropController',
                controllerAs: 'vm',
            }).result
                .then(() => {
                    vm.timestamp = new Date().getTime();
                });
        };
    }
}

ProfileController.$inject = ['$uibModal'];

angular.module('AlumniApp')
    .controller('ProfileController', ProfileController);

class UserProfileAvatarCropController {
    constructor($scope, $timeout, $uibModalInstance, UserResource, Toaster, fileReader, $rootScope, ErrorManager) {
        const vm = this;
        let cropper = null;

        // Dropzone options
        vm.oDzOptions = {
            url: '/upload_url',
            autoProcessQueue: false,
            clickable: '.dropzone',
            acceptedFiles: 'image/jpeg,image/png',
            maxFiles: 1,
            dictDefaultMessage: 'Click to add or drop logo <br/> Maximum file size: 10 Mb. Allowed formats: *.png, *.jpg',
            maxFilesize: 10
        };

        /**
         * Init Cropper
         */
        const fnInitCropper = () => {
            fileReader.readAsDataUrl(vm.oFile, $scope)
                .then((result) => {
                    const image = $('#crop')[0];
                    vm.oFileString = result;
                    image.onload = () => {
                        cropper = new Cropper(image, {
                            aspectRatio: 1,
                            zoomable: false,
                        });
                        $(image).on('crop', (e) => {
                            vm.oCropInfo = e.detail;
                            $scope.$apply();
                        });
                    };
                });
        };

        // Dropzone events
        vm.oDzCallBacks = {
            addedfile: (file) => {
                vm.oFile = file;
                fnInitCropper();
            },
            error: (oFile, sMessage) => {
                Toaster.toast({ message: sMessage, type: 'warning' });
                vm.fnRemoveFile();
            }
        };

        /**
         * Submit
         * @param event
         */
        vm.fnClickByEnter = (event) => {
            if (event.which !== 13) return;
            $timeout(() => {
                $(event.target).click();
            }, 0);
        };

        /**
         * Remove selected file
         */
        vm.fnRemoveFile = () => {
            if (!vm.oFile) return;

            vm.oFileString = null;
            vm.oCropInfo = null;
            vm.oDzMethods.removeFile(vm.oFile);
            vm.oFile = null;
        };

        /**
         * Upload avatar
         * @param oForm
         */
        vm.fnSubmit = (oForm) => {
            if (oForm.$invalid || vm.bIsSubmitting) return;

            vm.bIsSubmitting = true;

            vm.aErrors = [];
            cropper.getCroppedCanvas().toBlob((blob) => {
                UserResource.uploadOwnAvatar({}, { file: blob }).$promise
                    .then((oRes) => {
                        Toaster.toast({
                            message: 'Avatar was successfully uploaded.',
                            type: 'success'
                        });
                        $rootScope.oCurrentUser.avatarUrl = oRes.avatarUrl;
                        $uibModalInstance.close();
                        vm.bIsSubmitting = false;
                    })
                    .catch((oRes) => {
                        ErrorManager.serverToForm(oRes, oForm, vm.aErrors);
                        vm.bIsSubmitting = false;
                        if (oRes.data && oRes.data.code === 401) {
                            $uibModalInstance.dismiss();
                        }
                    });
            });
        };

        vm.fnClose = () => {
            if (vm.bIsSubmitting) return;
            $uibModalInstance.close({ bReload: false });
        };
    }
}

UserProfileAvatarCropController.$inject = ['$scope', '$timeout', '$uibModalInstance', 'UserResource', 'Toaster',
    'fileReader', '$rootScope', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('UserProfileAvatarCropController', UserProfileAvatarCropController);

class ProfileEditController {
    constructor($scope, $rootScope, Auth, UserResource, Toaster, FormManager, ErrorManager) {
        const vm = this;

        $rootScope.profilePageActiveTab = 1;
        $rootScope.bPageContentPaddingTop = false;
        this.bIsLoading = true;

        Auth.getCurrentUser(true)
            .then((oRes) => {
                this.oProfileData = {
                    firstName: oRes.firstName,
                    lastName: oRes.lastName
                };
                this.bIsLoading = false;
            })
            .catch((oRes) => {
                Toaster.toastError(oRes);
            });

        FormManager.watch($scope, 'oProfileForm');

        vm.fnSubmitProfile = (oForm) => {
            this.bIsLoading = true;
            UserResource.updateProfile(null, vm.oProfileData, null, null).$promise
                .then((oUpdateProfile) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Update was successful',
                        type: 'success'
                    });
                    $rootScope.oCurrentUser = oUpdateProfile;
                    this.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    this.bIsLoading = false;
                });
        };
    }
}

ProfileEditController.$inject = ['$scope', '$rootScope', 'Auth', 'UserResource', 'Toaster', 'FormManager', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('ProfileEditController', ProfileEditController);

class ChangePasswordController {
    constructor($scope, $rootScope, UserResource, Toaster, FormManager, ErrorManager) {
        const vm = this;

        $rootScope.bPageContentPaddingTop = false;

        this.bIsLoading = false;
        this.oPasswordData = {};

        FormManager.watch($scope, 'oChangePasswordForm');

        vm.fnSubmitProfile = (oForm) => {
            this.bIsLoading = true;
            UserResource.changePassword(null, vm.oPasswordData, null, null).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Update was successful',
                        type: 'success'
                    });
                    this.bIsLoading = false;
                    this.oPasswordData = {};
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    this.bIsLoading = false;
                });
        };
    };
}

ChangePasswordController.$inject = ['$scope', '$rootScope', 'UserResource', 'Toaster', 'FormManager', 'ErrorManager'];

angular.module("AlumniApp")
    .controller("ChangePasswordController", ChangePasswordController);

class ImportLogController {
    constructor(NgTableParams, LogCsvResource, $q, $filter, Toaster) {
        const vm = this;

        this.oTableParams = new NgTableParams({
            sorting: {
                date: 'desc'
            }
        }, {
            getData: oParams => $q.all([
                LogCsvResource.query({
                    order: Object.keys(oParams.sorting())[0],
                    orderby: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                    limit: oParams.count(),
                    offset: oParams.count() * (oParams.page() - 1)
                }).$promise,
                LogCsvResource.total().$promise
            ])
                    .then((aRes) => {
                        oParams.total(aRes[1].count);
                        return aRes[0];
                    })
                    .catch((oRes) => {
                        Toaster.toastError(oRes);
                    })
        });

        vm.fnGetFormatDate = nDate => $filter('date')(nDate, 'MM/dd/yy h:mm a');
    }
}

ImportLogController.$inject = ['NgTableParams', 'LogCsvResource', '$q', '$filter', 'Toaster'];

angular.module('AlumniApp')
    .controller('ImportLogController', ImportLogController);

class RegistrationController {
    constructor($scope, START_ROUTE, Auth, UserResource, Toaster, FormManager, ErrorManager, $state, PartnerResource, ProjectResource) {
        const vm = this;

        vm.brieflyDescribes = [
            'I need to be able to upload and update data in AlumniCompass.\n',
            'I need to be able to add, edit and delete Users in AlumniCompass.\n',
            'I need to be able to view reports in AlumniCompass.\n',
            'I need to be able to create and edit caseloads for students counseling/advising.\n',
            'I need to be able to view and search student profiles in AlumniCompass.\n'
        ];
        vm.oRegistrationData = {};
        vm.iCurrentStep = 1;
        vm.aSelectedBrieflyDescribes = [];

        FormManager.watch($scope, 'oRegistrationForm');

        /**
         * Get Partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll(null).$promise
                .then((oRes) => {
                    vm.oRegistrationData.level = 1;
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'error'
                    });
                    vm.bPartnersIsLoading = false;
                });
        };

        /**
         * Get Projects by partner
         */
        vm.fnGetProjects = () => {
            if (!vm.oRegistrationData.partner) return;

            vm.bProjectsIsLoading = true;
            ProjectResource.getAllByPartner({ partnerId: vm.oRegistrationData.partner }).$promise
                .then((oRes) => {
                    vm.oRegistrationData.project = null;
                    vm.aAllProjects = oRes;
                    vm.bProjectsIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'error'
                    });
                    vm.bProjectsIsLoading = false;
                });
        };

        /**
         * Submit form
         * @param oForm
         */
        vm.fnRegistration = (oForm) => {
            const oCurrentUser = _.clone(vm.oRegistrationData);
            if (+oCurrentUser.level === 1) {
                delete oCurrentUser.project;
            }

            oCurrentUser.brieflyDescribe = '';
            for (let i = 0; i < vm.brieflyDescribes.length; i++) {
                if (vm.aSelectedBrieflyDescribes[i]) {
                    oCurrentUser.brieflyDescribe += vm.brieflyDescribes[i];
                }
            }

            vm.bIsLoading = true;
            UserResource.registration(null, oCurrentUser, null, null).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.bIsLoading = false;
                    vm.oRegistrationData = {};
                    $state.go('auth.login');
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        /**
         * Get Current User
         */
        const fnGetCurrentUser = () => {
            Auth.getCurrentUser()
                .then((oUser) => {
                    vm.bIsLoading = false;
                    if (oUser) {
                        Toaster.toast({
                            message: 'You authorized',
                            type: 'warning'
                        });
                        $state.go(START_ROUTE);
                    }
                })
                .catch(() => {
                    vm.bIsLoading = false;
                });
        };

        /**
         * Go to step
         * @param step
         */
        vm.fnNextStep = (step) => {
            vm.iCurrentStep = step;
        };

        /**
         * Go to step
         * @param step
         */
        vm.fnPreviousStep = (step) => {
            vm.iCurrentStep = step;
        };

        /**
         * Validate Briefly Describes Field
         */
        vm.validateBrieflyDescribes = () => {
            vm.bBrieflyDescribesIsValid = false;

            _.forEach(vm.aSelectedBrieflyDescribes, (selectedBrieflyDescribe) => {
                if (selectedBrieflyDescribe) {
                    vm.bBrieflyDescribesIsValid = true;
                    return false;
                }
            });
        };

        fnGetCurrentUser();
        fnGetPartners();
    }
}

RegistrationController.$inject = ['$scope', 'START_ROUTE', 'Auth', 'UserResource', 'Toaster', 'FormManager', 'ErrorManager',
    '$state', 'PartnerResource', 'ProjectResource'];

angular.module('AlumniApp')
    .controller('RegistrationController', RegistrationController);

class ConfirmEmailController {
    constructor($state, Auth, Toaster) {
        const vm = this;

        vm.sConfirmToken = $state.params.confirmToken;

        Auth.confirmEmail(this.sConfirmToken)
            .then((oRes) => {
                Toaster.toast({
                    message: oRes.message,
                    type: 'success'
                });
                $state.go('auth.login');
            })
            .catch((oRes) => {
                Toaster.toastError(oRes);
                $state.go('auth.login');
            });
    }
}

ConfirmEmailController.$inject = ['$state', 'Auth', 'Toaster'];

angular.module('AlumniApp')
    .controller('ConfirmEmailController', ConfirmEmailController);

class FeedbackWindowController {
    constructor($uibModalInstance, FeedbackResource, Toaster, ErrorManager, FileUploader) {
        const vm = this;

        const oUploader = vm.oUploader = new FileUploader();

        vm.oFeedbackData = {
            subject: '',
            description: '',
            file: ''
        };

        vm.bIsLoading = false;

        vm.submit = (oForm) => {
            vm.bIsLoading = true;
            FeedbackResource.addFeedback({}, vm.oFeedbackData).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Feedback was successfully sent',
                        type: 'success'
                    });
                    vm.bIsLoading = false;
                    $uibModalInstance.close();
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                    if (oRes.data && oRes.data.code == 401) {
                        $uibModalInstance.close();
                    }
                });
        };

        vm.close = () => {
            $uibModalInstance.close();
        };

        oUploader.onWhenAddingFileFailed = function () {
            vm.oFeedbackData.file = null;
        };
        oUploader.onAfterAddingFile = function (fileItem) {
            vm.oFeedbackData.file = fileItem._file;
        };
    }
}

FeedbackWindowController.$inject = ['$uibModalInstance', 'FeedbackResource', 'Toaster', 'ErrorManager', 'FileUploader'];

angular.module('AlumniApp')
    .controller('FeedbackWindowController', FeedbackWindowController);

class ModalWindowFeedbackController {
    constructor($uibModal) {
        const modalWindow = this;

        modalWindow.openFeedbackWindow = () => {
            $uibModal.open({
                templateUrl: 'views/feedback-popup.html',
                backdropClass: 'modal-back',
                windowClass: 'modal-window',
                controller: 'FeedbackWindowController',
                controllerAs: 'vm'
            });
        };
    }
}

ModalWindowFeedbackController.$inject = ['$uibModal'];

angular.module('AlumniApp')
    .controller('ModalWindowFeedbackController', ModalWindowFeedbackController);

class ReportDetailsNewTabController {
    constructor(ReportResource, $stateParams, Toaster, $scope) {
        const vm = this;
        vm.reportLoaded = false;

        ReportResource.showById({ id: $stateParams.id }).$promise
            .then((oRes) => {
            vm.oCurrentReport = oRes;
		    var split_id = oRes.powerBIUrl.split('&groupId=')[0];
		    const sCurrentReportId = split_id.split('reportId=')[1];
		    vm.embedConfiguration = {
			    type: 'report',
			    tokenType: 1,
			    accessToken: vm.oCurrentReport.key,
			    id: sCurrentReportId,
			    name: 'Retail Analysis',
			    embedUrl: oRes.powerBIUrl,
			    allowFullScreen: true,
			    settings: {
				    filterPaneEnabled: !!oRes.report.enabledFilters,
				    navContentPaneEnabled: !!oRes.report.enabledTabs
			    }
		    };
	    })
            .catch(oRes => Toaster.toastError(oRes));

        vm.fullScreenReport = () => {
            powerbi.embeds[0].fullscreen();
        };

        vm.onEmbedded = () => {
            powerbi.embeds[0].on('loaded', () => {
                vm.reportLoaded = true;
                $scope.$apply();
            });
        };
    }
}

ReportDetailsNewTabController.$inject = ['ReportResource', '$stateParams', 'Toaster', '$scope'];

angular.module('AlumniApp')
    .controller('ReportDetailsNewTabController', ReportDetailsNewTabController);

class PowerBIWorkspaceManagementListController {
    constructor(NgTableParams, PowerBIWorkspaceResource, Toaster) {
        const vm = this;

        /**
         * Get partners names
         * @param aPartners
         * @returns {string}
         */
        const getPartnersNames = (aPartners) => {
            if (!Array.isArray(aPartners)) {
                return '';
            }

            let sPartnersNames = '';
            for (let i = 0; i < aPartners.length; i++) {
                sPartnersNames += (sPartnersNames.length > 0) ? `, ${aPartners[i].name}` : aPartners[i].name;
            }

            return sPartnersNames;
        };

        /**
         * Init table with power BI workspaces
         */
        vm.oTableParams = new NgTableParams({}, {
            getData: (oParams) => {
                vm.bIsLoading = true;

                return PowerBIWorkspaceResource.getForTable({
                    order: Object.keys(oParams.sorting())[0],
                    orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                    limit: oParams.count(),
                    offset: oParams.count() * (oParams.page() - 1)
                }).$promise
                    .then((oRes) => {
                        vm.bIsLoading = false;
                        oParams.total(oRes.total);
                        for (let i = 0; i < oRes.items.length; i++) {
                            oRes.items[i].partners = getPartnersNames(oRes.items[i].partners);
                        }
                        return oRes.items;
                    })
                    .catch((oRes) => {
                        vm.bIsLoading = false;
                        Toaster.toastError(oRes);
                    });
            }
        });

        /**
         * Delete Power BI Workspace
         * @param event
         * @param id
         */
        vm.fnDeletePowerBiWorkspace = (event, id) => {
            const bConfirm = confirm('The Power BI Workspace will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            vm.bIsLoading = true;
            return PowerBIWorkspaceResource.delete({ id }).$promise
                .then((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };
    }
}

PowerBIWorkspaceManagementListController.$inject = ['NgTableParams', 'PowerBIWorkspaceResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('PowerBIWorkspaceManagementListController', PowerBIWorkspaceManagementListController);

class PowerBIWorkspaceManagementAddController {
    constructor($scope, $state, PowerBIWorkspaceResource, PartnerResource, FormManager, Toaster, ErrorManager) {
        const vm = this;
        vm.aSelectedPartners = [];

        FormManager.watch($scope, 'oPowerBIWorkspaceForm');

        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmitReportingDatabase = (oForm) => {
            vm.bIsLoading = true;
            const oCurrentPowerBIWorkspace = _.clone(vm.oPowerBIWorkspaceData);

            PowerBIWorkspaceResource.add(oCurrentPowerBIWorkspace).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    $state.go('index.power-bi-workspace-management.list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        /**
         * Get All Partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bPartnersIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        fnGetPartners();
    }
}

PowerBIWorkspaceManagementAddController.$inject = ['$scope', '$state', 'PowerBIWorkspaceResource', 'PartnerResource',
    'FormManager', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('PowerBIWorkspaceManagementAddController', PowerBIWorkspaceManagementAddController);

class PowerBIWorkspaceManagementEditController {
    constructor($scope, $state, PowerBIWorkspaceResource, PartnerResource, FormManager, Toaster, ErrorManager, $stateParams) {
        const vm = this;
        FormManager.watch($scope, 'oPowerBIWorkspaceForm');

        /**
         * Get Power BI Workspace
         */
        const fnGetPowerBIWorkspace = () => {
            vm.bIsLoading = true;

            PowerBIWorkspaceResource.getById({ id: $stateParams.id }).$promise
                .then((oRes) => {
                    vm.iCurrentId = oRes.id;
                    vm.oPowerBIWorkspaceData = {
                        name: oRes.name,
                        description: oRes.description,
                        partners: _.map(oRes.partners, partner => partner.id),
                        DBUsername: oRes.DBUsername,
                        workspaceId: oRes.workspaceId
                    };
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };


        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmit = (oForm) => {
            vm.bIsLoading = true;
            const oClonePowerBIWorkspaceData = _.clone(vm.oPowerBIWorkspaceData);

            if (_.has(oClonePowerBIWorkspaceData, 'workspaceId')) {
                delete oClonePowerBIWorkspaceData.workspaceId;
            }

            PowerBIWorkspaceResource.update({ id: vm.iCurrentId }, oClonePowerBIWorkspaceData).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    $state.go('index.power-bi-workspace-management.list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        /**
         * Delete Power BI Workspace
         * @param event
         * @param id
         */
        vm.fnDeletePowerBiWorkspace = (event, id) => {
            const bConfirm = confirm('This Workspace will be deleted. Are you sure?');

            if (!bConfirm) return event.preventDefault();

            vm.bIsLoading = true;
            return PowerBIWorkspaceResource.delete({ id }).$promise
                .then((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.bIsLoading = false;
                    $state.go('index.power-bi-workspace-management.list');
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        /**
         * Get All Partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bPartnersIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        fnGetPowerBIWorkspace();
        fnGetPartners();
    }
}

PowerBIWorkspaceManagementEditController.$inject = ['$scope', '$state', 'PowerBIWorkspaceResource', 'PartnerResource',
    'FormManager', 'Toaster', 'ErrorManager', '$stateParams'];

angular.module('AlumniApp')
    .controller('PowerBIWorkspaceManagementEditController', PowerBIWorkspaceManagementEditController);

class ApplicationDatabaseManagementListController {
    constructor(NgTableParams, ApplicationDatabaseResource, Toaster) {
        const vm = this;

        vm.oTableParams = new NgTableParams({}, {
            getData: (oParams) => {
                vm.bIsLoading = true;

                return ApplicationDatabaseResource.getForTable({
                    order: Object.keys(oParams.sorting())[0],
                    orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                    limit: oParams.count(),
                    offset: oParams.count() * (oParams.page() - 1)
                }).$promise
                    .then((oRes) => {
                        vm.bIsLoading = false;
                        oParams.total(oRes.total);
                        return oRes.items;
                    })
                    .catch((oRes) => {
                        vm.bIsLoading = false;
                        Toaster.toastError(oRes);
                    });
            }
        });

        vm.fnDeleteApplicationDatabase = (event, id) => {
            const bConfirm = confirm('This Application Database will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            vm.bIsLoading = true;
            return ApplicationDatabaseResource.delete({ id }).$promise
                .then((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };
    }
}

ApplicationDatabaseManagementListController.$inject = ['NgTableParams', 'ApplicationDatabaseResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('ApplicationDatabaseManagementListController', ApplicationDatabaseManagementListController);

class ApplicationDatabaseManagementAddController {
    constructor($scope, $state, ApplicationDatabaseResource, PartnerResource, FormManager, Toaster, ErrorManager) {
        const vm = this;
        vm.oApplicationDatabaseData = {};

        FormManager.watch($scope, 'oNewApplicationDatabaseForm');

        vm.fnSubmitApplicationDatabase = (oForm) => {
            vm.bIsLoading = true;
            const oCurrentApplicationDatabase = _.clone(vm.oApplicationDatabaseData);

            ApplicationDatabaseResource.add(oCurrentApplicationDatabase).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    $state.go('index.application-database-management.list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bPartnersIsLoading = false;
                });
        };

        fnGetPartners();
    }
}

ApplicationDatabaseManagementAddController.$inject = ['$scope', '$state', 'ApplicationDatabaseResource', 'PartnerResource',
    'FormManager', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('ApplicationDatabaseManagementAddController', ApplicationDatabaseManagementAddController);

class ApplicationDatabaseManagementEditController {
    constructor($scope, $state, ApplicationDatabaseResource, PartnerResource, FormManager, Toaster, ErrorManager, $stateParams) {
        const vm = this;

        FormManager.watch($scope, 'oNewApplicationDatabaseForm');

        /**
         * Get Application Database
         */
        const fnGetAppDatabase = () => {
            vm.bIsLoading = true;

            ApplicationDatabaseResource.getById({ id: $stateParams.id }).$promise
                .then((oRes) => {
                    vm.iCurrentId = oRes.id;
                    vm.oApplicationDatabaseData = {
                        name: oRes.name,
			host: oRes.host,
                        partner: oRes.partner.id,
                        DBUsername: oRes.DBUsername,
                        DBPassword: oRes.DBPassword
                    };
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        /**
         * Get Partners
         */
        const fnGetPartners = () => {
            vm.bPartnersIsLoading = true;

            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.aAllPartners = oRes;
                    vm.bPartnersIsLoading = false;
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                    vm.bPartnersIsLoading = false;
                });
        };

        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmitApplicationDatabase = (oForm) => {
            vm.bIsLoading = true;

            ApplicationDatabaseResource.update({ id: vm.iCurrentId }, vm.oApplicationDatabaseData).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.bIsLoading = false;
                    $state.go('index.application-database-management.list');
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        /**
         * Delete Application Database
         * @param event
         * @param id
         */
        vm.fnDeleteApplicationDatabase = (event, id) => {
            const bConfirm = confirm('This Application Database will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            vm.bIsLoading = true;
            return ApplicationDatabaseResource.delete({ id }).$promise
                .then((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.bIsLoading = false;
                    $state.go('index.application-database-management.list');
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        fnGetAppDatabase();
        fnGetPartners();
    }
}

ApplicationDatabaseManagementEditController.$inject = ['$scope', '$state', 'ApplicationDatabaseResource', 'PartnerResource',
    'FormManager', 'Toaster', 'ErrorManager', '$stateParams'];

angular.module('AlumniApp')
    .controller('ApplicationDatabaseManagementEditController', ApplicationDatabaseManagementEditController);

class PartnerMngtListController {
    constructor(PartnerResource, Toaster, NgTableParams, $uibModal) {
        const vm = this;
        vm.aProcessing = [];

        vm.oTableParams = new NgTableParams({}, {
            getData: (oParams) => {
                const oSearchParams = {
                    order: Object.keys(oParams.sorting())[0],
                    orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                    limit: oParams.count(),
                    offset: oParams.count() * (oParams.page() - 1)
                };

                vm.bIsLoading = true;
                return PartnerResource.getWithPagination(oSearchParams).$promise
                    .then((oRes) => {
                        vm.bIsLoading = false;
                        oParams.total(oRes.total);
                        return oRes.items;
                    })
                    .catch((oRes) => {
                        vm.bIsLoading = false;
                        Toaster.toastError(oRes);
                    });
            }
        });

        /**
         * Create partner (open modal form)
         */
        vm.fnCreate = () => {
            $uibModal.open({
                templateUrl: 'views/create-edit-partner-pop-up.html',
                backdropClass: 'modal-back',
                windowClass: 'modal-window',
                controller: 'CreateEditPartnerPopUpController',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    Partner: null
                }
            }).result
                .then(() => {
                    vm.oTableParams.reload();
                });
        };

        vm.fnEdit = (oPartner) => {
            $uibModal.open({
                templateUrl: 'views/create-edit-partner-pop-up.html',
                backdropClass: 'modal-back',
                windowClass: 'modal-window',
                controller: 'CreateEditPartnerPopUpController',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    Partner: oPartner
                }
            }).result
                .then(() => {
                    vm.oTableParams.reload();
                });
        };

        vm.fnDelete = (oPartner) => {
            if (!oPartner || vm.aProcessing[oPartner.id]) return;

            if (!confirm('All the partner\'s data and the partner\'s users will be deleted. Continue?')) return;

            vm.aProcessing[oPartner.id] = true;
            PartnerResource.delete({ id: oPartner.id }).$promise
                .then((oRes) => {
                    vm.aProcessing[oPartner.id] = false;
                    Toaster.toast({ message: oRes.message, type: 'success' });
                    vm.oTableParams.reload();
                })
                .catch((oErr) => {
                    vm.aProcessing[oPartner.id] = false;
                    Toaster.toast({ message: oErr.message, type: 'error' });
                });
        };
    }
}

PartnerMngtListController.$inject = ['PartnerResource', 'Toaster', 'NgTableParams', '$uibModal'];

angular.module('AlumniApp')
    .controller('PartnerMngtListController', PartnerMngtListController);


class CreateEditPartnerPopUpController {
    constructor($uibModalInstance, PartnerResource, Toaster, ErrorManager, fileReader, $scope, Partner) {
        const vm = this;
        let cropper = null;
        vm.oPartner = {};

        if (Partner) {
            vm.oPartner.name = Partner.name;
            vm.oPartner.slug = Partner.slug;
            vm.oPartner.logoUrl = Partner.logoUrl;
            vm.oPartner.showFooter = Partner.show_footer;
            vm.bIsEditMode = true;
        }

        // Dropzone options
        vm.oDzOptions = {
            url: '/upload_url',
            autoProcessQueue: false,
            clickable: '.dropzone',
            acceptedFiles: 'image/jpeg,image/png',
            maxFiles: 1,
            dictDefaultMessage: 'Click to add or drop logo <br/> Maximum file size: 2 Mb. Allowed formats: *.png, *.jpg',
            maxFilesize: 2
        };

        /**
         * Init Cropper
         */
        const fnInitCropper = () => {
            fileReader.readAsDataUrl(vm.oFile, $scope)
                .then((result) => {
                    // Create image for set start crop coordinates
                    const oImage = new Image();
                    const $cropContainer = $('#crop');
                    oImage.src = result;
                    vm.oFileString = result;
                    oImage.onload = () => {
                        vm.aStartCoord = [0, 0, oImage.width, oImage.height];
                        cropper = new Cropper($cropContainer[0], {});
                        $cropContainer.on('crop', (e) => {
                            vm.oCropInfo = e.detail;
                        });
                    };
                });
        };

        // Dropzone events
        vm.oDzCallBacks = {
            addedfile: (file) => {
                $scope.oPartnerForm.$setDirty();
                vm.oFile = file;
                fnInitCropper();
            },
            error: (oFile, sMessage) => {
                Toaster.toast({ message: sMessage, type: 'warning' });
                vm.fnRemoveFile();
            }
        };

        /**
         * Create Partner
         * @param oPartnerData
         * @param oForm
         */
        const fnCreate = (oPartnerData, oForm) => {
            vm.bIsSubmitting = true;
            PartnerResource.create(oPartnerData).$promise
                .then((oRes) => {
                    vm.bIsSubmitting = false;
                    Toaster.toast({ message: oRes.message, type: 'success' });
                    $uibModalInstance.close();
                })
                .catch((oErr) => {
                    vm.bIsSubmitting = false;
                    ErrorManager.serverToForm(oErr, oForm, vm.aErrors);
                });
        };

        /**
         * Edit partner
         * @param oPartnerData
         * @param oForm
         */
        const fnUpdate = (oPartnerData, oForm) => {
            vm.bIsSubmitting = true;
            if (oPartnerData.logoUrl !== undefined) delete oPartnerData.logoUrl;
            PartnerResource.edit({ id: Partner.id }, oPartnerData).$promise
                .then((oRes) => {
                    vm.bIsSubmitting = false;
                    Toaster.toast({ message: oRes.message, type: 'success' });
                    $uibModalInstance.close();
                })
                .catch((oErr) => {
                    vm.bIsSubmitting = false;
                    ErrorManager.serverToForm(oErr, oForm, vm.aErrors);
                });
        };

        /**
         * Submit form (create partner)
         * @param oForm
         */
        vm.fnSubmit = (oForm) => {
            if (oForm.$invalid || vm.bIsSubmitting) return;

            vm.aErrors = [];
            const oPartnerData = _.cloneDeep(vm.oPartner);
            if (vm.oFile) {
                cropper.getCroppedCanvas().toBlob((blob) => {
                    oPartnerData.file = blob;
                });
            }

            if (Partner) {
                fnUpdate(oPartnerData, oForm);
            } else {
                fnCreate(oPartnerData, oForm);
            }
        };

        /**
         * Close modal
         */
        vm.fnClose = () => {
            $uibModalInstance.dismiss();
        };

        /**
         * Remove selected file
         */
        vm.fnRemoveFile = () => {
            if (!vm.oFile) return;

            const JcropAPI = $('#crop').data('Jcrop');
            if (JcropAPI) {
                JcropAPI.destroy();
            }
            vm.oFileString = null;
            vm.oCropInfo = null;
            vm.oDzMethods.removeFile(vm.oFile);
            vm.oFile = null;
        };
    }
}

CreateEditPartnerPopUpController.$inject = ['$uibModalInstance', 'PartnerResource', 'Toaster', 'ErrorManager', 'fileReader',
    '$scope', 'Partner'];

angular.module('AlumniApp')
    .controller('CreateEditPartnerPopUpController', CreateEditPartnerPopUpController);

class PublicPartnerReportController {
    constructor(ReportResource, Toaster, $scope, oCurrentPartner, $state, MAIN_SLUG, $stateParams) {
        const vm = this;

        vm.reportLoaded = false;

        const fnGetPublicReport = () => {
            if (!oCurrentPartner) {
                return $state.go('auth.login', { sPartnerSlug: MAIN_SLUG });
            }

            return ReportResource.getPublicBySlug({ slug: oCurrentPartner.slug, reportId: $stateParams.reportId }).$promise
                .then((oRes) => {
                    vm.oCurrentReport = oRes;
                    var split_id = oRes.powerBIUrl.split('&groupId=')[0];
                    const sCurrentReportId = split_id.split('reportId=')[1];
                    vm.embedConfiguration = {
                        type: 'report',
                        tokenType: 1,
                        accessToken: vm.oCurrentReport.key,
                        id: sCurrentReportId,
                        name: 'Retail Analysis',
                        embedUrl: oRes.powerBIUrl,
                        allowFullScreen: true,
                        settings: {
                            filterPaneEnabled: !!oRes.report.enabledFilters,
                            navContentPaneEnabled: !!oRes.report.enabledTabs
                        }
                    };
                })
                .catch((oRes) => {
                    vm.reportLoaded = true;
                    Toaster.toastError(oRes);
                });
        };

        vm.fullScreenReport = () => {
            powerbi.embeds[0].fullscreen();
        };

	function set_title() {    
	    var myIframe = document.getElementsByTagName('iframe');
		var elmnt = myIframe[0].contentWindow.document.getElementsByTagName("title");

	}

        vm.printReport = () => {
	 //   set_title();
            powerbi.embeds[0]
                .print()
                .catch((error) => {
                    Toaster.toastError(error);
                });
        };
	

        vm.onEmbedded = () => {
	    var i = 0;
	    (function waitForPowerBIReport() {
	        if (i >= 300 || powerbi.embeds.length > 0) {
		    return;
		}
	        else {
		    i++;
		    setTimeout(waitForPowerBIReport, 100);
		}
	    }());
	    if (powerbi.embeds.length > 0) {
	        powerbi.embeds[0].on('loaded', () => {
                    vm.reportLoaded = true;
                    $scope.$apply();
                });
	    }
        };

        fnGetPublicReport();
    }
}

PublicPartnerReportController.$inject = ['ReportResource', 'Toaster', '$scope', 'oCurrentPartner', '$state', 'MAIN_SLUG', '$stateParams'];

angular.module('AlumniApp')
    .controller('PublicPartnerReportController', PublicPartnerReportController);

class ProjectMngtController {
    constructor(PartnerResource, Toaster, NgTableParams, $uibModal, ProjectResource) {
        const vm = this;
        vm.aProcessing = [];

        vm.oTableParams = new NgTableParams({}, {
            getData: (oParams) => {
                const oSearchParams = {
                    order: Object.keys(oParams.sorting())[0],
                    orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
                    limit: oParams.count(),
                    offset: oParams.count() * (oParams.page() - 1)
                };

                vm.bIsLoading = true;
                return ProjectResource.getWithPagination(oSearchParams).$promise
                    .then((oRes) => {
                        vm.bIsLoading = false;
                        oParams.total(oRes.total);
                        return oRes.items;
                    })
                    .catch((oRes) => {
                        vm.bIsLoading = false;
                        Toaster.toastError(oRes);
                    });
            }
        });

        /**
         * Create project (open modal form)
         */
        vm.fnCreate = () => {
            $uibModal.open({
                templateUrl: 'views/create-edit-project-pop-up.html',
                backdropClass: 'modal-back',
                windowClass: 'modal-window',
                controller: 'CreateEditProjectPopUpController',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    Project: null
                }
            }).result
                .then(() => {
                    vm.oTableParams.reload();
                });
        };

        vm.fnEdit = (oProject) => {
            $uibModal.open({
                templateUrl: 'views/create-edit-project-pop-up.html',
                backdropClass: 'modal-back',
                windowClass: 'modal-window',
                controller: 'CreateEditProjectPopUpController',
                controllerAs: 'vm',
                backdrop: false,
                resolve: {
                    Project: oProject
                }
            }).result
                .then(() => {
                    vm.oTableParams.reload();
                });
        };

        vm.fnDelete = (oProject) => {
            if (!oProject || vm.aProcessing[oProject.id]) return;

            if (!confirm('All the project\'s data and users will be deleted. Continue?')) return;

            vm.aProcessing[oProject.id] = true;
            ProjectResource.delete({ id: oProject.id }).$promise
                .then((oRes) => {
                    vm.aProcessing[oProject.id] = false;
                    Toaster.toast({ message: oRes.message, type: 'success' });
                    vm.oTableParams.reload();
                })
                .catch((oErr) => {
                    vm.aProcessing[oProject.id] = false;
                    Toaster.toast({ message: oErr.message, type: 'error' });
                });
        };
    }
}

ProjectMngtController.$inject = ['PartnerResource', 'Toaster', 'NgTableParams', '$uibModal', 'ProjectResource'];

angular.module('AlumniApp')
    .controller('ProjectMngtController', ProjectMngtController);


class CreateEditProjectPopUpController {
    constructor($uibModalInstance, PartnerResource, Toaster, ErrorManager, ProjectResource, Project) {
        const vm = this;
        vm.bPartnersIsLoading = true;
        vm.oProject = {};

        if (Project) {
            vm.oProject.name = Project.name;
            vm.oProject.partner = Project.partner.id;
            vm.aPartners = [Project.partner];
            vm.bIsEditMode = true;
        } else {
            PartnerResource.getAll().$promise
                .then((oRes) => {
                    vm.bPartnersIsLoading = false;
                    vm.aPartners = oRes;
                })
                .catch((oErr) => {
                    vm.bPartnersIsLoading = false;
                    Toaster.toast({ message: oErr.message, type: 'error' });
                });
        }

        /**
         * Create project
         * @param oProjectData
         * @param oForm
         */
        const fnCreate = (oProjectData, oForm) => {
            vm.bIsSubmitting = true;
            ProjectResource.create(oProjectData).$promise
                .then((oRes) => {
                    vm.bIsSubmitting = false;
                    Toaster.toast({ message: oRes.message, type: 'success' });
                    $uibModalInstance.close();
                })
                .catch((oErr) => {
                    vm.bIsSubmitting = false;
                    ErrorManager.serverToForm(oErr, oForm, vm.aErrors);
                });
        };

        /**
         * Edit project
         * @param oProjectData
         * @param oForm
         */
        const fnUpdate = (oProjectData, oForm) => {
            vm.bIsSubmitting = true;
            if (oProjectData.partner) {
                delete oProjectData.partner;
            }
            ProjectResource.edit({ id: Project.id }, oProjectData).$promise
                .then((oRes) => {
                    vm.bIsSubmitting = false;
                    Toaster.toast({ message: oRes.message, type: 'success' });
                    $uibModalInstance.close();
                })
                .catch((oErr) => {
                    vm.bIsSubmitting = false;
                    ErrorManager.serverToForm(oErr, oForm, vm.aErrors);
                });
        };

        /**
         * Submit form (create partner)
         * @param oForm
         */
        vm.fnSubmit = (oForm) => {
            if (oForm.$invalid || vm.bIsSubmitting) return;

            vm.aErrors = [];
            const oProjectData = _.cloneDeep(vm.oProject);

            if (Project) {
                fnUpdate(oProjectData, oForm);
            } else {
                fnCreate(oProjectData, oForm);
            }
        };

        /**
         * Close modal
         */
        vm.fnClose = () => {
            $uibModalInstance.dismiss();
        };
    }
}

CreateEditProjectPopUpController.$inject = ['$uibModalInstance', 'PartnerResource', 'Toaster', 'ErrorManager', 'ProjectResource', 'Project'];

angular.module('AlumniApp')
    .controller('CreateEditProjectPopUpController', CreateEditProjectPopUpController);

class PowerBiUsersListController {
    constructor(NgTableParams, PowerBiUserResource, Toaster) {
        const vm = this;

/**
 *          * Init table with powerusers
 *                   */
	            vm.oTableParams = new NgTableParams({}, {
			                getData: (oParams) => {
						                vm.bIsLoading = true;

						                return PowerBiUserResource.getForTable({
									                    order: Object.keys(oParams.sorting())[0],
									                    orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
									                    limit: oParams.count(),
									                    offset: oParams.count() * (oParams.page() - 1)
									                }).$promise
						                    .then((oRes) => {
									                            vm.bIsLoading = false;
									                            oParams.total(oRes.total);
									                            return oRes.items;
									                        })
						                    .catch((oRes) => {
									                            vm.bIsLoading = false;
									                            Toaster.toastError(oRes);
									                        });
						            }
			            });


        vm.fnDeleteUser = (event, id) => {
            const bConfirm = confirm('This user will be deleted. Are you sure?');
            if (!bConfirm) {
                return event.preventDefault();
            }

            return PowerBiUserResource.delete({ id }).$promise
                .then(() => {
                    Toaster.toast({
                        message: 'Delete was successful',
                        type: 'success'
                    });
                    vm.oTableParams.reload();
                })
                .catch((oRes) => {
                    Toaster.toastError(oRes);
                });
        };
    }
}

PowerBiUsersListController.$inject = ['NgTableParams', 'PowerBiUserResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('PowerBiUsersListController', PowerBiUsersListController);

class PowerBiUserManagementAddController {
    constructor($scope, $state, PowerBiUserResource, FormManager, Toaster,
                ErrorManager) {
        const vm = this;

        // Avoid jump
        $('.nav-tabs li a').click((e) => {
            e.preventDefault();
        });

        FormManager.watch($scope, 'oNewUserForm');

        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmitUser = (oForm) => {
            const oCurrentUser = _.clone(vm.oUserData);
            if (vm.groupLevel !== 2) {
                delete oCurrentUser.project;
            }
            vm.bFormLoading = true;
            PowerBiUserResource.add(oCurrentUser).$promise
                .then(() => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: 'Add new powerBi user',
                        type: 'success'
                    });
                    $state.go('index.users-management.powerbiuser-list');
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bFormLoading = false;
                });
        };

    }
}

PowerBiUserManagementAddController.$inject = ['$scope', '$state', 'PowerBiUserResource', 'FormManager', 'Toaster', 'ErrorManager'];

angular.module('AlumniApp')
    .controller('PowerBiUserManagementAddController', PowerBiUserManagementAddController);

class PowerBiUserManagementEditController {
    constructor($scope, $state, PowerBiUserResource, FormManager, Toaster, ErrorManager, $stateParams) {
        const vm = this;
        FormManager.watch($scope, 'oPowerBiUserForm');

        /**
         * Get Power BI User
         */
        const fnGetPowerBiUser = () => {
            vm.bIsLoading = true;

            PowerBiUserResource.getById({ id: $stateParams.id }).$promise
                .then((oRes) => {
                    vm.iCurrentId = oRes.id;
                    vm.oPowerBiUserData = {
                        username: oRes.username,
                        password: oRes.password
                    };
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };


        /**
         * Submit form
         * @param oForm
         */
        vm.fnSubmit = (oForm) => {
            vm.bIsLoading = true;
            const oClonePowerBiUserData = _.clone(vm.oPowerBiUserData);

       //     if (_.has(oClonePowerBiUserData, 'workspaceId')) {
       //         delete oClonePowerBiUserData.workspaceId;
       //     }

            PowerBiUserResource.update({ id: vm.iCurrentId }, oClonePowerBiUserData).$promise
                .then((oRes) => {
                    FormManager.setPristineWatched();
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    $state.go('index.users-management.powerbiuser-list');
                    vm.bIsLoading = false;
                })
                .catch((oRes) => {
                    ErrorManager.serverToForm(oRes, oForm, Toaster.wait());
                    vm.bIsLoading = false;
                });
        };

        /**
         * Delete Power BI Workspace
         * @param event
         * @param id
         */
        vm.fnDeletePowerBiUser = (event, id) => {
            const bConfirm = confirm('This User will be deleted. Are you sure?');

            if (!bConfirm) return event.preventDefault();

            vm.bIsLoading = true;
            return PowerBiUserResource.delete({ id }).$promise
                .then((oRes) => {
                    Toaster.toast({
                        message: oRes.message,
                        type: 'success'
                    });
                    vm.bIsLoading = false;
                    $state.go('index.users-management.powerbiuser-list');
                })
                .catch((oRes) => {
                    vm.bIsLoading = false;
                    Toaster.toastError(oRes);
                });
        };

        fnGetPowerBiUser();
    }
}

PowerBiUserManagementEditController.$inject = ['$scope', '$state', 'PowerBiUserResource', 'FormManager', 'Toaster', 'ErrorManager', '$stateParams'];

angular.module('AlumniApp').controller('PowerBiUserManagementEditController', PowerBiUserManagementEditController);

class UsersLogListController {
    constructor(NgTableParams, UserLogResource, Toaster) {
        const vm = this;

/**
 *          * Init table with powerusers
 *                   */
	            vm.oTableParams = new NgTableParams({}, {
			                getData: (oParams) => {
						                vm.bIsLoading = true;

						                return UserLogResource.getForTable({
									                    order: Object.keys(oParams.sorting())[0],
									                    orderBy: _.toUpper(oParams.sorting()[Object.keys(oParams.sorting())[0]]),
									                    limit: oParams.count(),
									                    offset: oParams.count() * (oParams.page() - 1)
									                }).$promise
						                    .then((oRes) => {
									                            vm.bIsLoading = false;
									                            oParams.total(oRes.total);
									                            return oRes.items;
									                        })
						                    .catch((oRes) => {
									                            vm.bIsLoading = false;
									                            Toaster.toastError(oRes);
									                        });
						            }
			            });

    }
}

UsersLogListController.$inject = ['NgTableParams', 'UserLogResource', 'Toaster'];

angular.module('AlumniApp')
    .controller('UsersLogListController', UsersLogListController);
